export default {
    "en": {
        "passwords": {
            "password": "Passwords must be at least six characters and match the confirmation.",
            "reset": "Your password has been reset!",
            "sent": "We have e-mailed your password reset link!",
            "token": "This password reset token is invalid.",
            "user": "We can't find a user with that e-mail address."
        },
        "wallet": {
            "sms-code-text": "Your verification code to confirm your OpenFly booking is: {code}",
            "sms-code-text-withdrawal": "Your verification code to withdraw funds from your OpenFly Wallet is: {code}",
            "pilot-missing-funds-1-days": "Hello,\nFor your information, the sponsor's wallet is not funded with the amount of the overrun linked to the estimate for flight {trips}.\nThe OpenFly team",
            "pilot-missing-funds-3-days": "Hello,\nFor your information, the sponsor's wallet is not funded for flight {trips}.\nThe OpenFly team",
            "user-missing-funds": "Hello,\nYour electronic wallet is not funded for your flight {trips}.\nPlease fund it: {link}\nThe OpenFly team"
        },
        "ios-configuration": {
            "payload-description": "To enjoy all your account's benefits, complete the initialization of your services OpenFly by clicking \"Install\"."
        },
        "calendar": {
            "pilot-unavailable-calendar-prefix": "Unavailability: ",
            "plane-unavailable-calendar-prefix": "Unavailability: ",
            "plane-calendar-display-name": "OpenFly - {registration}",
            "bookings-calendar-display-name": "OpenFly - Bookings",
            "pilot-calendar-display-name": "OpenFly - Pilot",
            "bookings-title-prefix": "OpenFly : ",
            "booking-user": "Booker",
            "routing-leg": "Routing",
            "booking-calendar-description": "Hello,\\n\\n{bookingUser} organized a trip via OpenFly in which you participate.\\n\\nYour pilot, {pilotName}, can be reached by phone at {pilotPhone}.\\n\\nBest regards,\\nThe OpenFly team\\n\\nwww.openfly.fr",
            "unavailable-label": "Unavailable"
        },
        "contact": {
            "form-title": "Contact Us",
            "name": "Name",
            "email": "Email Address",
            "subject": "Subject",
            "body": "Message",
            "submit": "Send",
            "continue": "Continue",
            "message-sent": "<p class=\"contact-sent-confirmation\">Thank you for your message.<br>We will come back to you shortly.</p>",
            "phone": "Phone Number"
        },
        "rewriting": {
            "press-url": "press-area",
            "testimonies-url": "testimonies",
            "sitemap-url": "sitemap",
            "faq-url": "faq",
            "job-candidature-url": "jobs",
            "registration-form-download-url": "registration-form",
            "fly-from": "private-plane-airports",
            "flight": "flight",
            "flight-from": "flight-from-",
            "meeting-invite-url": "invitation-evenement",
            "meeting-invite-confirmation-url": "confirmation-inscription-evenement",
            "airport": "airport",
            "private-flight-cost-url": "private-flight-cost",
            "cci-gap-offer-url": "offer-cci-gap",
            "tos-url": "openfly-terms-of-service.pdf",
            "passenger-feedback-url": "customer-feedback",
            "most-searched-trips": "most-searched-trips",
            "pilot-insurance": "pilots-insurance"
        },
        "login": {
            "form-header": "Log In",
            "email": "Email Address",
            "password": "Password",
            "password-forgotten": "Forgotten password ?",
            "remember-me": "Remember me",
            "submit": "Log in"
        },
        "our-services": {
            "offers": {
                "free": {
                    "name": "OPEN",
                    "pricing": "Free,<br>unlimited duration<sup style=\"font-size: 12px;\">1</sup>",
                    "pricing-individual": "Free,<br>unlimited duration<sup style=\"font-size: 12px;\">1</sup>",
                    "details": [
                        "Platform access<br><span style=\"font-size: 11px;\">(referenced aircraft, prices, aircraft informations, …)</span>",
                        "Access to aircraft reservations through private aviation companies"
                    ],
                    "footnotes": [
                        "<sup>1</sup> You only pay for the rental of the aircraft owned by an airline and the piloting service."
                    ]
                },
                "discovery": {
                    "name": "DISCOVERY<br>OFFER<sup style=\"font-size: 12px;\">2</sup>",
                    "pricing": "1190€ exc. VAT / 6 months<sup style=\"font-size: 12px;\">3</sup>",
                    "pricing-individual": "1158.33€ exc. VAT / 6 months<sup style=\"font-size: 12px;\">3</sup>",
                    "details": [
                        "Platform access<br><span style=\"font-size: 11px;\">(referenced aircraft, prices, aircraft informations, …)</span>",
                        "Access to aircraft reservations through private aviation companies",
                        "Access to booking private owners' aircraft with lower prices",
                        "Access to direct contact with pilots and owners via electronic messaging",
                        "Access to aircraft and pilots availability calendars",
                        "No commission on completed flights"
                    ],
                    "footnotes": [
                        "<sup>2</sup> One-time offer.",
                        "<sup>3</sup> This amount is paid to OpenFly. The payment of the private plane rental and the piloting service is made directly to the owner and the pilot."
                    ]
                },
                "full": {
                    "name": "1 YEAR OFFER",
                    "pricing": "1990€ exc. VAT / 12 months<sup style=\"font-size: 12px;\">3</sup>",
                    "pricing-individual": "1990€ exc. VAT / 12 months<sup style=\"font-size: 12px;\">3</sup>",
                    "details": [
                        "Platform access<br><span style=\"font-size: 11px;\">(referenced aircraft, prices, aircraft informations, …)</span>",
                        "Access to aircraft reservations through private aviation companies",
                        "Access to booking private owners' aircraft with lower prices",
                        "Access to direct contact with pilots and owners via electronic messaging",
                        "Access to aircraft and pilots availability calendars",
                        "No commission on completed flights",
                        "Support/Hotline service with guidance through the booking process"
                    ],
                    "footnotes": [
                        "<sup>3</sup> This amount is paid to OpenFly. The payment of the private plane rental and the piloting service is made directly to the owner and the pilot."
                    ]
                }
            },
            "premium-club": "PREMIUM CLUB",
            "register": "REGISTER",
            "individual": "Individuals",
            "professional": "Professionals",
            "private-aircraft": {
                "header": "Private aircraft rental",
                "subheader": "Suitable for travel from region to region or from region to Europe",
                "description": "These aircraft are owned by private owners, who provide their aircraft and the services of a professional pilot. These private aircraft benefit from the best rental rates, starting at 300€/hour."
            },
            "company-aircraft": {
                "header": "Chartering of company aircraft",
                "subheader": "Suitable for travelling on longer distances or with more passengers.",
                "description": "Chartering of companies' aircraft, usually larger airplanes. They are referenced on the OpenFly platform by airlines specialized in business aviation."
            }
        },
        "seo-airport": {
            "airport-list": "Airports list",
            "airport": "{airport} Airport",
            "most-frequent-destinations": "Most frequent destinations",
            "airport-map-subtitle": "With OpenFly, thanks to a private plane, you can travel to any airport in Europe.\n    <br>More than 250 airplanes are now available for rental through OpenFly. Sign up for free to see the planes available near your city!"
        },
        "auth": {
            "failed": "Incorrect email address or password.",
            "throttle": "Too many connection attempts. Please retry in {seconds} seconds."
        },
        "insurance-faq": {
            "faq-title": "FAQ AIRCRAFT CIVIL LIABILITY INSURANCE FOR THE USER PILOT",
            "bloc-title-1": "What does the aircraft Civil Liability insurance for user pilots cover? ",
            "bloc-description-1": "The insurance proposed by OpenFly is an aircraft Civil Liability insurance for the User Pilot of an aircraft,\n    covering the civil liability of the pilot when he uses as captain an aircraft he does not own. If an accident occurs,\n    this insurance compensates passengers and third parties on the ground if the compulsory insurance of the aircraft is insufficient.<br><br>\n    This insurance is not an Individual Accident Insurance as it does not cover the pilot personally. It is the pilot's responsibility to take out his own individual accident insurance. <br><br>\n    Similarly, this insurance does not cover damage to the aircraft used. The latter is covered by the compulsory insurance taken out by the owner. ",
            "bloc-title-2": "What types of aircraft are covered by the insurance?",
            "bloc-description-2": "The insurance proposed by OpenFly concerns all single or twin-engine piston aircraft, turbine aircraft with a\n    maximum take-off weight of less than 5,700kg and with a maximum of 9 passengers on board as defined by\n    national regulations for European Union countries and, by default, French regulations. ",
            "bloc-title-3": "Are all pilots eligible?",
            "bloc-description-3": "Eligible pilots must meet the criteria required by OpenFly to offer their piloting services on the platform and be\n    validated by the aircraft owner, i.e. :<br><br>\n    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- To be a CPL pilot with at least 500 hours of flying as a pilot-in-command, including at least 20\n    hours in the last 12 months, and 100 hours as an IFR captain.<br>\n    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- Have up-to-date licenses and qualifications<br>\n    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- Have an up-to-date class 1 medical certificate.<br><br>\n    However, pilots of Swiss and Monegasque nationality are not eligible for this insurance.",
            "bloc-title-4": "s my flight covered if I fly an aircraft registered outside Europe? In particular if my aircraft is N-Reg? ",
            "bloc-description-4": "Yes, your flight is covered if you are flying an aircraft registered outside Europe as long as your main country of\n    residence is an EASA* member.<br><br>\n    * EASA member countries include EU countries as well as other countries <a href=\"https://www.easa.europa.eu/en/domains/international-cooperation/easa-by-country/map\" target=\"_blank\">listed here</a>",
            "bloc-title-5": "Who is covered by the aircraft Civil Liability insurance for user pilots?",
            "bloc-description-5": "The insurance proposed by OpenFly covers the civil liability of the user pilot towards passengers and third\n    parties on the ground up to a limit of 1,000,000 euros per claim in excess of the insurance policy covering the\n    aircraft used (all damages combined and up to a limit of 3,000,000 euros per year). The pilot is not covered\n    for damages suffered personally but is covered for damages for which he/she could be held responsible\n    towards his passengers, their luggage and third parties on the ground. ",
            "bloc-title-6": "What to do in case of an accident? ",
            "bloc-description-6": "In the event of an accident, please take the following steps:<br><br>\n    1. Notify the fire brigade and the gendarmerie if necessary. <br><br>\n    2. Report the incident to the broker or insurer mentioned on the insurance certificate usually included in the\n    aircraft's logbook.<br><br>\n    3. Notify <b>OpenFly at +33 (0)2 52 59 59 59</b> and contact the insurance broker <b>SAAM Verspieren Group at\n    +33 (0)1 49 64 10 61</b>.<br><br>\n    The insurance proposed by OpenFly will only be complementary to the aircraft insurance if the latter is\n    insufficient for the damage suffered. This is why it is necessary to start by contacting the insurer indicated on the\n    aircraft's insurance certificate. ",
            "bloc-title-7": "Does this insurance replace mandatory insurance?",
            "bloc-description-7": "No, the insurance proposed by OpenFly to pilots does not replace the compulsory insurances but comes as a\n    complement in case of insufficiency of the latter. If you suffer a prejudice, it is the compulsory Civil Liability\n    insurance attached to the aircraft that will work in the first instance. If the cover provided by this insurance is not\n    sufficient, then the proposed insurance will be activated to provide you with the necessary guarantees up to a\n    limit of 1,000,000 euros per claim and 3,000,000 euros per year. ",
            "bloc-title-8": "In which countries are flights covered? ",
            "bloc-description-8": "The guarantees of this insurance produce their effects in the Member States of the European Union, the United\n    Kingdom, Switzerland, Monaco and the countries bordering the Mediterranean with the exception of Algeria,\n    Libya, Sudan, the Province of North Sinai in Egypt, Lebanon, Russia, Ukraine and Belarus as well as excluding\n    any country declared under embargo by France or the United Nations. <br><br>\n    The insurance covers cross-border flights by aircraft if they take place within the area covered by the insurance\n    contract.",
            "bloc-title-9": "What are the steps to take out this insurance? ",
            "bloc-description-9": "To take advantage of the Aircraft Liability Insurance for user pilots, you must be a professional pilot meeting the validation criteria to appear on the platform.<br><br>\n    The insurance is applied by default to all missions accepted by the pilot.",
            "bloc-title-10": "How much does the aircraft Civil Liability insurance for user pilots cost? ",
            "bloc-description-10": "The contribution to the insurance for each reservation is 3.5% of the amount of the reservation.",
            "bloc-title-11": "Does the insurance compensate me if the flight is cancelled?",
            "bloc-description-11": "No, this is not cancellation insurance.",
            "bloc-title-12": "Do we transfer any of your personal data to our insurance partners?",
            "bloc-description-12": "Yes, in order to confirm your eligibility to benefit from this insurance programme, we have to share some of your\n    personal data with our partner. We transmit to SAAM Verspieren, the identity (Name and First Name) of all\n    flight participants and some flight parameters (date, airports, ...). Please note that your data is transferred in a\n    secure manner and that our partners must respect the right to the protection of personal data. ",
            "bloc-title-13": "Where can I see the insurance certificate?",
            "bloc-description-13": "Click on the following link to view the insurance certificate<br><br><a class=\"md-button md-button md-raised md-primary md-theme-default md-theme-default insurance-button\" href=\"/files/fr/openfly_rc_pilotes.pdf\" target=\"_blank\">Insurance certificate</a>"
        },
        "pages": {
            "fly": {
                "title-with-departure": "Flight departing from {departure}",
                "subtitle-with-departure": "Select your destination airport:",
                "title-without-departure": "{nbAirports} airports available in {country}",
                "h1-without-departure": "Private plane rental in more than {nbAirports} airports in {country}",
                "subtitle-without-departure": "Select your departure airport:",
                "page-title-without-departure": "{nbAirports} business aviation airports in {country}",
                "airport-label": "{city} Airport",
                "flight-label": "{from} - {to}",
                "slogan-sub": "Travel everywhere in Europe thanks to an airport network covering the whole European territory"
            },
            "seo": {
                "airport": {
                    "page-title": "Private plane renting - {airportName}",
                    "page-description": "{airportName} - Business executives : use OpenFly for your business trips instead of your car or the train. Everywhere in France, there is a plane waiting for you...",
                    "page-content-description": "Rent a private plane departing from {airportName} and fly directly to more than 4000 destinations in Europe thanks to OpenFly, the 1st portal for aircraft and private jet rentals. Download the OpenFly application, indicate your departure airport, your destination then choose your private plane among the 250 referenced devices and select the professional pilot with whom you want to fly. It’s that quick and easy. Travel quickly and flexibly from{airportName}. You can find the most popular destinations from {airportName} below. Hotels near {airportName} are also referenced.",
                    "address": "Address",
                    "phone": "Phone Number",
                    "hotels-near-airport": "Hotels near {airportName} airport",
                    "cities-near-airport": "Cities near {airportName} airport",
                    "hotel-nearby": "{hotelName} ({distance} km)",
                    "city-nearby": "{cityName} ({distance} km)",
                    "frequent-destinations-from-airport": "Frequent destinations from {airportName} airport",
                    "destination-label": "{fromAirport} {toAirport}",
                    "possible-destinations": "{count} destinations from {airportName}"
                },
                "airports": {
                    "page-title": "Airports",
                    "map-label": "{airportName} Airport<br><a href=\"{href}\">Read more</a>"
                },
                "read-more": "Read more",
                "wikipedia-source": "Source: Wikipedia",
                "all-destinations-from": "All destinations from {fromAirport}",
                "enter-destination-from": "Enter a destination from {fromAirport}",
                "seo-flight-suggestion": {
                    "page-title": "Private plane rental from {fromAirport} to {toAirport}",
                    "page-description-1": "With OpenFly, the 1st private aircraft rental portal, you can rent a plane or a private jet to travel from {fromAirport} to {toAirport}, easily, without having to change.",
                    "page-description-2": "<b>{fromAirport} to {toAirport} by private plane:</b><br><br>The journey from {fromAirport} to {toAirport} can be made by private plane within a flight time of {minFlightTime}.<br>The cost of renting a private plane for this journey starts from {minPrice} excluding tax.<br><br>Download the OpenFly application, indicate your departure airport (here {fromAirport}), your destination (here {toAirport}) then choose your private plane from the listed aircraft and select the professional pilot with whom you want to make your flight. Booking a private plane becomes very simple.<br>More than 4000 destinations in Europe are thus directly accessible by plane private, from {fromAirport} or {toAirport}, via private planes and private jets referenced on OpenFly."
                }
            },
            "co2-emissions-per-km": "CO2 emissions per km",
            "consumption": "Fuel consumption",
            "less-than-a-jet": "{percentage} % less than a bi-reactor jet**",
            "per-passenger": "Per passenger",
            "comparison-with-cessna-latitude": "Comparison with the Cessna Latitude jet"
        },
        "meeting-invite": {
            "email": "Email Address",
            "phone": "Phone Number*",
            "lastname": "Last Name*",
            "firstname": "First Name*",
            "register": "Register",
            "registration-confirmed-title": "Registration Confirmed",
            "registration-confirmed-message": "Your registration has been processed. Thank you.",
            "page-title": "Event Registration",
            "company": "Company*",
            "continue-on-airaffaires": "Continue on openfly.fr",
            "contact-infos": "For more information, you can contact us by phone: +33252595959"
        },
        "admin": {
            "cancel": "Cancel",
            "save": "Save",
            "confirm": "Confirm",
            "delete": "Delete",
            "close": "Close",
            "go-back": "Back",
            "content-management-heading": "Content Management",
            "tech-stats-heading": "Technical Statistics",
            "stats-heading": "Statistics",
            "registration-report-menu": "Registration Tunnel",
            "db-perfs-menu": "Database Performance",
            "short-urls-menu": "Short URLs",
            "dashboard": {
                "title": "Dashboard"
            },
            "content-pages-menu": "Content Pages",
            "content-pages": {
                "add-page": "Add Page",
                "add-lang": "Add Language",
                "key": "Key",
                "edition": "Edit",
                "preview": "Preview {lang}",
                "page-title": "Title",
                "saved": "Page Saved",
                "lang": "Language",
                "page-url": "URL Link",
                "publish": "Publish Draft",
                "lang-code": "Language Code",
                "delete-page": "Delete this Page",
                "delete-page-text": "This action will delete all contents linked to this page, its draft, and its published version.",
                "new-block": "[NEW BLOCK]",
                "sequence": "Sequence",
                "column": "Column",
                "block": "Block",
                "order": "Order",
                "offset": "Offset",
                "quote": "Quote",
                "author_role": "Author Role",
                "author_name": "Author",
                "background": "Background",
                "type": "Block Type",
                "types": {
                    "html": "HTML",
                    "image": "Image",
                    "testimony": "Testimony",
                    "search-engine": "Search Engine"
                },
                "restore": "Restore",
                "need-2-chars": "The Language Code must contain 2 characters.",
                "lang-still-registered": "This language already exists",
                "success": {
                    "publish": "The page has been published.",
                    "add-lang": "The language has been added.",
                    "add-page": "The page has been added.",
                    "add-block": "The block has been added: sequence {sequence}, column {column}, order {order}",
                    "delete-page": "THe page has been deleted.",
                    "update-value": "Value saved: <i>{value}</i>",
                    "restore": "The page has been restored to its published version."
                },
                "errors": {
                    "publish": "Failed to publish page.",
                    "add-lang": "Failed to add page.",
                    "add-block": "Failed to add block.",
                    "delete-lang": "Failed to save value <i>{key} = {value}, back to {key} = {old}</i>",
                    "update-value": "Failed to delete page.",
                    "restore": "Failed to restore page.",
                    "restore-no-published-page": "There is no published version of this page. Impossible to restore."
                }
            },
            "metadata-menu": "Metadata du site",
            "metadata": {
                "edit-dialog-title": "Modifier une entrée",
                "add-dialog-title": "Ajouter une entrée",
                "key-header": "Clé",
                "value-header": "Valeur",
                "actions-header": "Actions",
                "locale-header": "Langue",
                "add-entry": "Ajouter",
                "key-exists-already": "Un enregistrement existe déjà pour cette clé.",
                "confirm-delete-title": "Supprimer une entrée",
                "confirm-delete": "Êtes-vous sûr de vouloir supprimer cette entrée des metadata ?"
            },
            "footer-menu": "Footer",
            "footer": {
                "column-header": "Colonne",
                "order-header": "Ordre",
                "block-title-header": "Titre du bloc",
                "actions-header": "Actions",
                "title-header": "Titre ({locale})",
                "add-block": "Ajouter un bloc",
                "add-block-dialog-title": "Ajout d'un nouveau bloc",
                "edit-block-dialog-title": "Modification d'un bloc",
                "block-key-header": "Clé du bloc",
                "class-header": "Classe CSS",
                "url-header": "URL",
                "label-header": "Libellé",
                "confirm-delete-block-title": "Supprimer un bloc",
                "confirm-delete-block": "Êtes-vous sûr de vouloir supprimer ce bloc du footer ?",
                "edit-block-links-dialog-title": "Édition des liens d'un bloc",
                "nb-links-header": "Nombre de liens",
                "edit-label-header": "Libellé ({locale})",
                "edit-url-header": "URL ({locale})",
                "image-header": "Image",
                "target-header": "Cible (propriété HTML \"target\")",
                "edit-link-dialog-title": "Modification d'un lien",
                "add-link-dialog-title": "Ajout d'un lien",
                "confirm-delete-link-title": "Supprimer un lien",
                "confirm-delete-link": "Êtes-vous sûr de vouloir supprimer ce lien du footer ?"
            },
            "tech-stats": {
                "avg-db-time-per-page": "Temps de requêtage moyen par page"
            },
            "faq-menu": "FAQ",
            "faq": {
                "add-section": "Ajouter",
                "add-question": "+ Question",
                "title": "Titre",
                "key": "Clé",
                "question": "Question",
                "answer": "Réponse",
                "lang": "Langue",
                "delete-section": "Supprimer la section",
                "delete-question": "Supprimer la question",
                "save-section": "Sauvegarder",
                "add-section-success": "La section à bien été ajoutée",
                "add-section-failed": "Une erreur est survenue lors de la création de la section",
                "delete-section-success": "La section à bien été supprimée",
                "delete-section-failed": "Une erreur est survenue lors de la suppression de la section",
                "delete-question-success": "La question à bien été supprimée",
                "delete-question-failed": "Une erreur est survenue lors de la suppression de la question",
                "save-section-success": "La section à bien été sauvegardée",
                "save-section-failed": "Une erreur est survenue lors de la sauvegarde de la section",
                "reorder-section-success": "Les sections ont bien été réordonnées",
                "reorder-section-failed": "Une erreur est survenue lors du réordonnancement des sections",
                "confirm-delete-question": "Êtes vous sûr de vouloir supprimer cette question ?",
                "confirm-delete-section": "Êtes vous sûr de vouloir supprimer cette section ? Toutes les questions sous-jacentes seront également supprimées.",
                "error": "Une erreur est survenue lors de votre requête"
            },
            "press-menu": "Espace Presse",
            "press": {
                "title": "Titre",
                "key": "Clé",
                "name": "Nom",
                "ytb_url": "Lien Youtube",
                "pdf_url": "Lien PDF",
                "url": "Lien",
                "date_published": "Date de publication",
                "logo_url": "Lien du logo",
                "add-source": "Ajouter une source",
                "add-source-title": "Ajout d'une source",
                "delete-source": "Suppression d'une source",
                "save-source": "Sauvegarder",
                "confirm-delete-source": "Êtes vous sur de vouloir supprimer cette source ? Ceci supprimera également toutes ses entrées associées. Cette action est irréversible.",
                "add-entry": "Ajouter une entrée",
                "add-entry-title": "Ajout d'une entrée",
                "delete-entry": "Suppression d'une entrée",
                "confirm-delete-entry": "Êtes vous sur de vouloir supprimer cette entrée ? Cette action est irréversible.",
                "save-entry": "Sauvegarder l'entrée",
                "save-source-success": "La source a bien été sauvegardée.",
                "save-source-failed": "Une erreur est survenue lors de la sauvegarde de la source.",
                "add-source-success": "La source a bien été ajoutée.",
                "add-source-failed": "Une erreur est survenue lors de l'ajout de la source.",
                "delete-source-success": "La source a bien été supprimée.",
                "delete-source-failed": "Une erreur est survenue lors de la suppression de la source.",
                "delete-entry-success": "L'entrée a bien été sauvegardée.",
                "delete-entry-failed": "Une erreur est survenue lors de la suppression de l'entrée.",
                "nb-entries": [
                    "{count} entrée pour cette source",
                    "{count} entrées pour cette source"
                ],
                "unvisible": "(Non visible)"
            },
            "leave-page": "Modifications non sauvegardées",
            "confirm-leave-page": "Vous avez des modifications en cours sur cette page. Êtes vous sur de vouloir la quitter ?",
            "forms-heading": "Formulaires",
            "meetings-menu": "Inscriptions événements",
            "meetings": {
                "email-header": "Email",
                "phone-header": "Téléphone",
                "lastname-header": "Nom",
                "firstname-header": "Prénom",
                "company-header": "Entreprise",
                "meetings-list": "Liste des événements",
                "date-header": "Date inscription",
                "export-participants": "Exporter",
                "nb-registered-participants": "{count} inscrit(s)"
            },
            "registration-report": {
                "search-title": "Recherche",
                "list-title": "Liste des utilisateurs entrés dans le tunnel",
                "date-header": "Date d'inscription",
                "email-header": "Email",
                "name-header": "Nom",
                "phone-header": "Téléphone",
                "city-header": "Ville",
                "step-header": "Étape",
                "step-indicator-header": "Indicateur d'étape",
                "from-date": "Date de début",
                "to-date": "Date de fin",
                "prev-period": "Période préc.",
                "next-period": "Période suiv.",
                "export-list": "Exporter",
                "nb-results": "{nb} utilisateur(s)"
            },
            "short-urls": {
                "add-entry": "Ajouter",
                "short-url-header": "URL courte",
                "full-url-header": "URL complète",
                "edit-dialog-title": "Modifier une entrée",
                "add-dialog-title": "Ajouter une entrée",
                "confirm-delete-title": "Supprimer une entrée",
                "confirm-delete": "Êtes-vous sûr de vouloir supprimer cette URL courte ?",
                "short-url-exists-already": "Cette URL courte existe déjà."
            }
        },
        "mobile": {
            "title": "Mobile App",
            "description": "You can download the app on your smartphone."
        },
        "password-reset": {
            "passwords.token": "The token has expired",
            "passwords.user": "Incorrect email address",
            "passwords.reset": "Password has been reset"
        },
        "email": {
            "hello": "Hello,",
            "online-version": "Access online version",
            "header": "Pioneer in low-emission private aviation",
            "trouble-link": "If you can't click on the \"{actionText}\" button, copy and paste the following URL<br> in your web browser :",
            "regards": "<br>Best Regards,<br><br>The Openfly Team",
            "default-salutation": "Best regards,",
            "default-signature": "Best Regards,<br><br>The Openfly Team",
            "before-footer-text": "You are receiving this email as a member of OpenFly",
            "before-footer-text-no-member": "You receive this mail from OpenFly",
            "unsubscribe": "<a id=\"unsubscribe-link\" href=\"{target}\">Unsubscribe</a> to stop receiving communications from us.",
            "copyright": "As per the terms of the Informatic and Liberty law of 01/06/1978, you have a right to access, modify, and delete your data, and to oppose its use.\n        If you wish to use that right, you can write to privacy@openfly.fr, stating your first and last name, email address and, if possible,\n        your client reference in order to ensure a speedy processing of your request.\n        <br>\n        You can access and change your informations (email addresses, postal address, name change...) at any time in the \"My Account\" page.\n        <br>\n        <br>\n        To learn more about our privacy policy, please read the \"<a href=\"{link}\" target=\"_blank\">Privacy policy</a>\" page on our website openfly.fr.\n        <br>\n        <br>",
            "copyright-no-link": "As per the terms of the Informatic and Liberty law of 01/06/1978, you have a right to access, modify, and delete your data, and to oppose its use.\n        If you wish to use that right, you can write to privacy@openfly.fr, stating your first and last name, email address and, if possible,\n        your client reference in order to ensure a speedy processing of your request. <br>\n        You can access and change your informations (email addresses, postal address, name change...) at any time in the \"My Account\" page.<br><br>\n        To learn more about our privacy policy, please read the \"Privacy Policy\" page on our website openfly.fr. <br><br>",
            "arrival": "Arrival",
            "departure": "Departure",
            "estimation": "Estimation:",
            "speed-unit": "km/h",
            "from-price": "From",
            "sponsor": "The sponsor",
            "the-pilot": "The pilot",
            "the-owner": "The owner",
            "dear-member": "Dear member,",
            "dear-owner": "Dear owner,",
            "dear-pilot": "Dear pilot,",
            "dear-passenger": "Dear passenger,",
            "taxes": {
                "ht": "excl. tax",
                "ttc": "incl. tax"
            },
            "passengers-with-number": "{passengers} passengers",
            "privacy": "All the data you will fill in on our website <a href=\"www.openfly.fr\">www.openfly.fr</a> are protected with a secure access and will stay strictly private.",
            "trip_type": {
                "multi-legs": "Multi leg",
                "round-trip": "Round Trip",
                "one-way": "One way"
            },
            "date_type": {
                "arrival": "Arrive at",
                "departure": "Leave at"
            },
            "registration": {
                "confirm-email-subject": "OpenFly - Email Address Confirmation",
                "thanks-for-registering": "Thank you for registering on OpenFly!",
                "please-confirm-email": "Please verify your email address ({email}) by clickink the following link:",
                "click-here-to-confirm-email": "Verify my email address",
                "welcome-to-the-club": "Welcome to Club OpenFly !",
                "welcome-to-the-club-text": "\n            You just subscribed to Club OpenFly, and are now a member.<br>More than 120 planes are at your disposal for your business travels.<br><br>\n            Your account will be fully activated in two business days. In the meantime, you can already access the platform, look at the available airplanes, and the estimates. As soon as your account is activated, you'll be able to book flights and plan your trips.\n        ",
                "credentials-reminder": "Here is your username to connect to your account:",
                "username": "Your username",
                "password": "Password",
                "welcome-to-the-club-conclusion": "\n            The whole team is at your disposal.<br><br>\n            All data you'll enter on our website openfly.fr are protected by a secure access, and stay strictly confidential.<br>\n            Following regulations, you can, at any moment, access your account and modify your personal data.\n        ",
                "registration-complete-subject": "Welcome to Club OpenFly !",
                "create-password": "In order to complete your account's creation, please create your password using the link below.",
                "click-here-to-create-password": "Create my password",
                "welcome-to-the-demo": "Welcome to your Club OpenFly trial.",
                "welcome-to-the-demo-text": "\n            Your trial of Club OpenFly is now active for a period of {days} days.\n            You can already access the platform, browse the destinations, the planes, and the price estimates.x.\n        "
            },
            "contact": {
                "greeting": "Hello",
                "infos": "<p>A new contact request has been created on {domain} :<ul>\n            <li>Nom : {name}</li>\n            <li>Email : {email}</li>\n            <li>Phone : {phone}</li>\n            <li>Message : <pre>{body}</pre></li>\n        </ul></p>",
                "infos-press": "<p>A new press information request has been created on {domain} :<ul>\n            <li>Nom : {name}</li>\n            <li>Email : {email}</li>\n            <li>Phone : {phone}</li>\n            <li>Message : <pre>{body}</pre></li>\n        </ul></p>",
                "subject": "New information request on {domain}",
                "subject-press": "New press information request on {domain}"
            },
            "contact-copy": {
                "subject": "OpenFly - Your information request",
                "header": "Request for information registered",
                "greeting": "Hello,",
                "content": "<p>Your information request has been sent.</p><p>We will get back to you as soon as possible. As a reminder, here is the content of your request:</p>",
                "infos": {
                    "name": "Name:",
                    "email": "Email:",
                    "phone": "Phone:",
                    "message": "Content:"
                },
                "signature": "Sincerely,<br><br>The OpenFly Team",
                "website": {
                    "fr": "OpenFly.fr",
                    "ch": "OpenFly.ch"
                },
                "phone": {
                    "fr": "+ 33 2 52 59 59 59",
                    "ch": "+33 2 52 59 59 59"
                }
            },
            "last-users-report": {
                "subject": "Rapport des utilisateurs inscrits",
                "last-users-since": "{count} utilisateurs sont passés par le tunnel d'inscription entre {from} et {to}",
                "steps": {
                    "not-via-tunnel": "Non inscrit par le tunnel",
                    "confirm-email": "Page: Confirmation email",
                    "select-destination": "Page: Selection de destination",
                    "flight-suggestions": "Page: Suggestions de vol",
                    "fill-profile": "Page: Formulaire profile",
                    "entity-infos": "Page: Formulaire entreprise",
                    "select-service": "Page: Sélection du mode d'abonnement",
                    "select-service-demo": "Page: Mode découverte activé",
                    "select-service-payment": "Page: Paiement",
                    "select-service-bill": "Page: Payer plus tard",
                    "show-bill": "Page: Info payer plus tard",
                    "submit-bill": "Payer plus tard: Fin de parcours",
                    "payment": "Page: Paiement",
                    "payment-error": "Paiement échoué: {error}",
                    "payment-3D-secure": "Paiement: Redirigé vers 3D Secure",
                    "payment-3D-secure-failed": "Paiement: 3D Secure paiement échoué",
                    "payment-card-rejected": "Paiement: Carte rejetée",
                    "payment-complete": "Paiement: Fin de parcours",
                    "registration-complete-freemium": "Enregistrement complété freemium"
                },
                "created": "Date de création",
                "email": "Email",
                "names": "Nom Prénom",
                "phone": "Téléphone",
                "city": "Ville",
                "step": "Étape",
                "registration-step-indicator": "Indicateur d'étape profil"
            },
            "team-signature": "\n        <p>Best Regards,<br>\n        Team OpenFly<br>\n        +33 2 52 59 59 59</p>\n    ",
            "alexandra-signature": "<p>Alexandra, Club OpenFly</p>",
            "failed-payment": {
                "subject": "Payment failure",
                "intro": "Un paiement pour l'adhésion a échoué pour l'entreprise suivante :",
                "company-name": "Nom",
                "contact-name": "Nom du contact",
                "contact-phone": "Téléphone",
                "contact-mail": "Adresse email",
                "error-info": "Le message d'erreur suivant a été reçu : {message}"
            },
            "meeting-registration-confirmation": {
                "subject": "Registration to an event confirmed",
                "greeting": "Hello,",
                "confirmation": "<p>Your registration to the following event has been taken into account:</p>\n            <p style=\"text-align: center;\">{meetingName}</p>"
            },
            "booking-reminder-unanswered24h-to-us": {
                "subject": "Demande de réservation sans réponse"
            },
            "booking-cancelled-by-pilot-to-us": {
                "subject": "Réservation annulée par le pilote"
            },
            "booking-cancelled-by-owner-to-us": {
                "subject": "Réservation annulée par le propriétaire"
            },
            "booking-validation-reminder-96h-to-us": {
                "subject": "Flight validation pending",
                "greeting": "Flight validation pending",
                "explanation": "Hello,<br><br>\n        Booking n°{booking_id} par {entity_name} for a flight on {booking_flight_date} at {booking_flight_time} hasn't been validated by the pilot yet.<br />\n        Pilot : {pilote_name}.<br />",
                "link-button": "See booking details"
            },
            "booking-collect-feedback": {
                "passenger": {
                    "subject": "Your trip {departure_airport} -> {arrival_airport}",
                    "header": "Your trip {departure_airport} -> {arrival_airport}",
                    "greeting": "Dear passenger,",
                    "content": "\n                Hello {firstname},\n                <br><br><br>\n\n                Following the trip you organized the {departure_time}, from {departure_airport} to {arrival_airport}, we would like to hear from you about the flight and the pilot who flew.\n                <br><br>\n\n                The collected notes and comments will be published on OpenFly to recommend the most relevant pilots and planes to Club members.\n            ",
                    "button": "Share my feedback on my trip",
                    "co2": "All the emissions from this trip were offset by {entity_name}, i.e. {co2} tonnes of CO2. The CO2 contribution went directly to the <a href=“https://aero4good.org” target=“_blank”>Aero4good</a> association. "
                },
                "pilot": {
                    "subject": "Your feedback on the client {entity_name} - Votre vol {departure_airport} -> {arrival_airport}",
                    "header": "Your feedback on the client {entity_name}",
                    "greeting": "Dear pilot,",
                    "content": "\n                Hello {firstname},\n                <br><br><br>\n\n                Following the trip you made on {departure_time}, from {departure_airport} to {arrival_airport}, we would like to hear from you about the client {name}.\n                <br><br>\n\n                This notice will not be sent to the customer. The notes and comments collected will only be used to qualify and moderate the opinions left by this customer following this flight.\n                <br><br>\n\n                You can also write a Return on Experience (REX) and share it with the owner of the aircraft or other pilots registered on the OpenFly platform.\n            ",
                    "button": "Share my feedback"
                }
            },
            "job-candidature": {
                "subject": "Nouvelle candidature",
                "greeting": "Bonjour,",
                "intro": "Une nouvelle candidature a été reçue sur openfly.fr.",
                "lastname": "Nom",
                "firstname": "Prénom",
                "email": "Adresse email",
                "phone": "Téléphone",
                "job-name": "Poste",
                "english-level": "Niveau d'anglais",
                "message": "Message"
            },
            "passenger-feedback-alert": {
                "subject": "Nouvel avis à valider",
                "greeting": "Bonjour",
                "intro": "Un nouvel avis a été rédigé par le passager {passengerFirstname} {passengerLastname} pour le vol suivant: {company} -  {departure} &gt; {arrival} - {departureDate}",
                "validate": "<a href=\"{url}\">Valider l'avis</a>"
            },
            "pilot-document-uploaded": {
                "subject": "New document uploaded by {pilotFirstname} {pilotLastname}",
                "greeting": "Hello,",
                "intro": "{pilotFirstname} {pilotLastname} uploaded a new document : {documentName}.",
                "view": "<a href=\"{url}\">View profile</a>",
                "view-label": "View profile"
            },
            "pilot-feedback-alert": {
                "subject": "Nouvel avis d'un pilote",
                "greeting": "Bonjour",
                "intro": "Un nouvel avis avec commentaires a été rédigé par le pilote {pilotFirstname} {pilotLastname} pour le vol suivant:  {departure} &gt; {arrival} - {departureDate}",
                "validate": "<a href=\"{url}\">Voir l'avis</a>"
            },
            "pilot-price-update": {
                "subject": "Modification of pilot price",
                "greeting": "Hello",
                "intro": "{pilotFirstname} {pilotLastname} has changed his prices.",
                "view": "<a href=\"{url}\">View</a>",
                "view-label": "View"
            },
            "plane-price-update": {
                "subject": "Modification of owner price",
                "greeting": "Hello",
                "intro": "{ownerFirstname} {ownerLastname} has changed is prices for the aircraft {plane}-number.",
                "view": "<a href=\"{url}\">View</a>"
            },
            "long-pilot-unavailability": {
                "subject": "Unavailability of more than 15 days to come",
                "greeting": "Hello",
                "intro": "The pilot {pilotFirstname} {pilotLastname} has added an unavailability from {startDate} to {finishDate}.",
                "view": "<a href=\"{url}\">View</a>"
            },
            "long-plane-unavailability": {
                "subject": "Unavailability of more than 15 days to come",
                "greeting": "Hello",
                "intro": "{ownerFirstname} {ownerLastname} a ajout&eacute; has added an unavailability for the aircraft {plane}-number, from {startDate} to {finishDate}.",
                "view": "<a href=\"{url}\">View</a>"
            },
            "reset-password": {
                "subject": "Password Reset Request",
                "greeting": "Dear member,",
                "explanation": "<p>Hello,</p><p>To reset your password, please click on the link below:</p>",
                "click-here-to-reset-password": "Reset my password",
                "not-asked": "<p>If you haven't requested a password reset, please ignore this email.</p>"
            },
            "account-confirmation": {
                "greeting": "Account Activation",
                "link-button": "Activate your account",
                "explanation": "Hello <b>{firstname} {lastname}</b>,<br>To activate your account, please click on the button below"
            },
            "booking-airport": {
                "subject": "New OpenFly booking request to your airport",
                "greeting": "Hello",
                "line_1": "A new trip was booked on the OpenFly platform, which will and on your airport. Here are this booking’s details, and the taxes amount that we estimated for the trip.        ",
                "line_2": "If this estimate is correct, you can confirm using the button below.<br/>If it’s incorrect, you can signal this to us by clicking on the “Modify Estimate” button.",
                "line_the_plane": "The plane",
                "aircraft-type": "Type",
                "mtow": "MTOW",
                "aircraft-base": "Base",
                "registration-number": "Registration number",
                "base-airport": "Base airport",
                "weight": "Weight",
                "line_estimation_details": "Estimate details",
                "estimated_taxes_by_openfly": "Taxes estimated by OpenFly",
                "estimated_taxes_by_airport": "Taxes estimated by the airport",
                "link-button_validate": "Validate estimate",
                "link-button_change": "Change estimate"
            },
            "booking-pilot": {
                "subject": "New Booking Request",
                "header": "New Booking Request<br><small><i>Booking n°: {number}</small>",
                "greeting": "Dear pilot,",
                "line_2_individual": "<strong>{entity}-name</strong> booked a flight on {planes}-number airplane(s), including your {plane}-model registered {plane}-number.",
                "line_2_professional": "<strong>{entity}-name</strong> booked a flight on {planes}-number airplane(s), including your {plane}-model registered {plane}-number.",
                "line_legs_1": "We calculated the following routes:",
                "line_legs_2": "If these routes suit you, you can confirm this booking as-is.",
                "line_legs_3": "You also have the possibility to modify the proposed routes, check the estimated taxes, and send a refined proposal to the client.",
                "line_3": "Before accepting the request, we invite you to correct, if necessary, the route proposed by OpenFly and to refine the amounts of the estimate accordingly: flight time, airport taxes and handling fees.<br><br>At the end of the trip, you agree to invoice the amount you have accepted or proposed to the client.",
                "line_4": "As a reminder, <strong>you won’t be listed as available on the platform for the period running from {departure}-date to {arrival}-date</strong> until you answer this booking.",
                "line_wallet": "The total amount of the estimate has already been set aside in the customer’s wallet, and will be transferred to the plane’s owner and to yourself once the flight will be complete.",
                "useful_informations": "<strong>Useful informations - {airportName}</strong>",
                "link-button": "ANSWER BOOKING REQUEST",
                "passengers": "<font size=\"5\"><b>The passengers :</b></font>"
            },
            "booking-owner": {
                "subject": "Booking request - Departure from {airport} on {date}",
                "greeting": "Dear owner,",
                "booking-number": "Booking Number : {number}",
                "hello": "Hello {firstname} {lastname},<br><br>",
                "line_individual_single_choice": "{entity} has booked a flight on your plane {plane}-model, registered {plane}-number with the following pilot:",
                "line_individual_multiple_choices": "{entity} has booked a flight on {planes}-number airplane(s), including your airplane {plane}-model, registered {plane}-number with the following pilot:",
                "line_professional_single_choice": "The following company {entity} has booked a flight on your plane {plane}-model, registered {plane}-number with the following pilot:",
                "line_professional_multiple_choices": "The following company {entity} has booked a flight on {planes}-number airplane(s), including your airplane {plane}-model, registered {plane}-number with the following pilot:",
                "line_wallet": "The total amount of the estimate has already been set aside in <strong>{entity}-name</strong>’s wallet, and will be transferred to the pilot and to yourself once the flight will be complete.",
                "link-button": "FLIGHT DETAILS",
                "contact-needed": "If needed, you can contact {entity}-firstname {entity}-lastname :",
                "line_discount_discovery_mode": "This flight was booked thanks to the First Flight Offer discount of -{percent}% you offered on your aircraft.",
                "line_discount_fidelity": "This flight was booked thanks to the loyalty discount of -{percent}% you offered on your aircraft.",
                "line_discount_last_minute": "This flight was booked thanks to the Last Minute discount of -{percent}% you offered on your aircraft.",
                "line_discount_early_booking": "This flight was booked thanks to the Early Booking discount of -{percent}% you offered on your aircraft.",
                "line_discount_temporary_discount": "This flight was booked thanks to the temporary discount of -{percent}% you offered on your aircraft."
            },
            "booking-flight-changes-to-owner": {
                "subject": "The pilot has sent a new estimate to a Premium OpenFly Member",
                "greeting": "Hi {firstname},",
                "line_1": "The pilot, {firstname} {lastname}, authorized to fly your {plane}-model, has sent a new estimate to an OpenFly Club Member, for the following trip{trips}.",
                "line_2": "To review these changes, and the impact they have on the total amount for this booking, click on the button below:",
                "link-button": "VIEW DETAILS"
            },
            "booking-member-confirmed": {
                "subject": "Reservation accepted by the pilot {fullname}",
                "greeting": "Booking Confirmed by the pilot {fullname}",
                "header": "Reservation request accepted<br><small><i>Folder n°: {number}</small>",
                "explanation": "Hello {firstname} {lastname},<br><br>Your booking, listed above, departing from <b>{departure}-airport</b> on <b>{departure}-date</b> abord plane <b>{plane}-model</b> has been <b>accepted by your pilot!</b>",
                "information-warning": "If you have any questions, or wish to change passengers, please contact your pilot:",
                "comment": "Good day, and have a nice flight!",
                "link-button": "BOOK ANOTHER FLIGHT",
                "departure-from": "Flight departing from {departure}",
                "passengers": "<font size=\"5\"><b>The passengers :</b></font>",
                "services": "<font size=\"5\"><b>Services at destination :</b></font>",
                "title-taxi": "Taxis and chauffeurs",
                "title-rental": "Car hire and shuttles",
                "salutation": "The OpenFly team",
                "security-info": "For security reasons, certain articles are not accepted on board the aircraft, and in particular explosives, gas or firecrackers, or any product identified as \"dangerous\" in the IATA air regulations which can be consulted on the Internet.",
                "payment-info": "Please make the pre-payment of the reservation <b>within 72 hours</b>, otherwise your booking will be cancelled.",
                "proceed-to-payment-button": "Access to pre-payment",
                "title-services": "Services at destination"
            },
            "booking-passenger-confirmed": {
                "subject": "Booking Confirmed from {departure}-airport on {departure}-date",
                "header": "Booking Confirmed",
                "greeting": "Hello {firstname} {lastname},",
                "explanation": "{fullnameUser} organized a trip via OpenFly in which you participate.",
                "flight_professional": "The company {entity} is organizing this trip as private air transport, on behalf, by entering into two separate contracts:\n        <br>&bull; one for the piloting services provided by the professional Pilot that was selected, and\n        <br>&bull; one for the dry lease of the aircraft with the owner of said aircraft",
                "flight_individual": "{entity} is organizing this trip as private air transport, on behalf, by entering into two separate contracts:\n        <br>&bull; one for the piloting services provided by the professional Pilot that was selected, and\n        <br>&bull; one for the dry lease of the aircraft with the owner of said aircraft",
                "line": "The pilot, {pilotFullname}, can be reached on {pilotPhone}.",
                "comment": "Good day, and have a nice flight!",
                "add-to-calendar": "Add to my calendar",
                "salutation": "The OpenFly team",
                "security-info": "For security reasons, certain articles are not accepted on board the aircraft, and in particular explosives, gas or firecrackers, or any product identified as \"dangerous\" in the IATA air regulations which can be consulted on the Internet."
            },
            "booking-owner-confirmed": {
                "subject": "Booking Confirmed by the pilot {fullname}",
                "greeting": "Dear owner,",
                "explanation": "The booking departing from <b>{departure}-airport</b> on <b>{departure}-date</b> abord your plane <b>{plane}-model</b> has been <b>accepted by the pilot!</b>",
                "information-warning": "If you have any questions, please contact the pilot:",
                "comment": "Have a nice day.",
                "payment-info": "The client must now pay the total amount of the reservation into his wallet within 72 hours."
            },
            "booking-pilot-confirmed": {
                "subject": "Booking Confirmed",
                "greeting": "Dear pilot,",
                "explanation": "You confirmed the booking after, departing from <b>{departure}-airport</b> on <b>{departure}-date</b> aboard plane <b>{plane}-model</b> registered <b>{plane}-number</b>",
                "information-warning-individual": "As a reminder, all future trips with this person must be booked through our platform, as stated in our <a href=\"https://dev.openfly.fr/en/openfly-terms-of-service.pdf\">Terms and Conditions</a>, under a penalty of 10 000€.",
                "information-warning-professional": "As a reminder, all future trips with this company must be booked through our platform, as stated in our <a href=\"https://dev.openfly.fr/en/openfly-terms-of-service.pdf\">Terms and Conditions</a>, under a penalty of 10 000€.",
                "comment": "Have a nice day, and a nice flight!",
                "contact-needed": "If needed, you can contact the booking company: ",
                "link-button": "BOOKING DETAILS",
                "passengers": "The passengers"
            },
            "booking-member-validated": {
                "greeting": "Flight Completed",
                "header": "Flight Completed<br><small><i>booking n°: {number}</small>",
                "explanation": "Your flight, listed above, departing from <b>{departure}-airport</b> on <b>{departure}-date</b> abord plane <b>{plane}-model</b> has been <b>marked as completed by your pilot!</b><br/>Funds have been transferred from your wallet to that of the owner and pilot.<br/>You will soon receive the pilot's and the plane owner's invoices.",
                "information-warning": "If you have any questions about the invoice, please contact the pilot:",
                "comment": "Have a nice day !",
                "link-button": "BOOK ANOTHER FLIGHT",
                "additional-charges-info": "Your pilot specified that this trip was subject to important modifications, the billed amount might be higher than the initial estimate."
            },
            "booking-owner-validated": {
                "subject": "Flight completed",
                "header": "Flight completed<br><small><i>booking n°: {number}</small>",
                "greeting": "Dear owner,",
                "explanation": "The flights listed above, departing from <b>{departure}-airport</b> on <b>{departure}-date</b> abord plane <b>{plane}-model</b> has been <b>marked as complete by the pilot</b>.",
                "wallet-transfer": "The funds have been transferred from the client's OpenFly Wallet to yours.",
                "send-invoice": "Please send your invoice as soon as possible to the booking company.",
                "information-warning": "If you have any questions, please contact the pilot:",
                "comment": "Have a nice day",
                "invoice-address": "Here is the invoice address:",
                "line_discount_discovery_mode": "As a reminder, <b>this flight was booked using the First Flight Offer discount of -{percent}% </b>you offered on your aircraft. <b>The following prices already take this into account.</b>",
                "line_discount_fidelity": "As a reminder, <b>this flight was booked using the loyalty discount of -{percent}% </b>you offered on your aircraft. <b>The following prices already take this into account.</b>",
                "line_discount_last_minute": "As a reminder, <b>this flight was booked using the Last Minute discount of -{percent}% </b>you offered on your aircraft. <b>The following prices already take this into account.</b>",
                "line_discount_early_booking": "As a reminder, <b>this flight was booked using the Early Booking discount of -{percent}% </b>you offered on your aircraft. <b>The following prices already take this into account.</b>",
                "line_discount_temporary_discount": "As a reminder, <b>this flight was booked using the temporary discount of -{percent}% </b>you offered on your aircraft. <b>The following prices already take this into account.</b>",
                "line_delivery_exemption_time": "<b>{minute} minutes were offered on the overall routing.</b>",
                "contact-client": "Contact client"
            },
            "booking-pilot-validated": {
                "subject": "Flight Completed",
                "header": "Flight completed<br><small><i>booking n°: {number}</small>",
                "booking": "Booking n°{id}",
                "greeting": "Dear pilote,",
                "explanation": "Hello {firstname},<br><br>You marked as complete the flight listed above, departing from <b>{departure}-airport</b> on <b>{departure}-date</b> aboard plane <b>{plane}-model</b> registered <b>{plane}-number</b>.",
                "wallet-transfer": "The funds have been transferred from the client's OpenFly Wallet to yours.",
                "send-invoice": "Please send your invoice as soon as possible to the booking company.",
                "information-warning-individual": "As a reminder, all future trips with this person must be booked through our platform, as stated in our <a href=\"https://dev.openfly.fr/en/openfly-terms-of-service.pdf\">Terms and Conditions</a>, under a penalty of 10 000€.",
                "information-warning-professional": "As a reminder, all future trips with this company must be booked through our platform, as stated in our <a href=\"https://dev.openfly.fr/en/openfly-terms-of-service.pdf\">Terms and Conditions</a>, under a penalty of 10 000€.",
                "comment": "Have a nice day !",
                "contact-needed": "If you have any questions, please contact the booking company:",
                "link-button": "Booking details"
            },
            "actual_pilot_flight": "Pro Pilot Allowance : ",
            "actual_pilot_nights": "Pilot nights : ",
            "actual_pilot_immobilization": "Pilot Immobilization : ",
            "pilot_setup": "Pilot setup : ",
            "booking-cancelled-by-pilot-to-member": {
                "subject-cancel": "Booking no. {booking}-id Canceled - {airports} of {departure}-date",
                "subject-refuse": "One of your selected pilots declined the booking for a {airports} trip",
                "subject-refuse-single": "The selected pilot declined the booking for a {airports} trip",
                "header-cancel": "Cancelled reservation request",
                "header-refuse": "Reservation request refused",
                "header-refuse-single": "Reservation request refused",
                "greeting": "Dear member,",
                "explanation-cancel": "{pilotName}, your pilot, canceled your booking request for the following trip:",
                "explanation-refuse": "{pilotName}, your pilot, declined your booking request for the following trip:",
                "line_reason": "The pilot selected the following reason: <b>\"{motif}\"</b>",
                "line_other_offer_waiting": "A pilot can still respond to your request.",
                "line_other_offers_waiting": "Your {waitingOffers} other choices can still answer your request",
                "line_estimate_waiting": "You still have an estimate waiting for a reply on this booking, you can review it again and answer it by clicking on the button below:",
                "link-estimate-button": "Check estimate",
                "line_all_choices_declined": "All of your selected pilots unfortunately declined your booking request.",
                "comment": "We are sorry for the inconvenience.<br>You can immediately start a new search to select new offers by clicking on the button below.",
                "link-button": "BOOK ANOTHER PLANE",
                "refund-info": "The funds for this booking are now available in your e-wallet. You can use them for another booking or <a href=\"{refundLink}\">make a withdrawal of funds</a>."
            },
            "booking-cancelled-by-openfly-to-member": {
                "subject-cancel": "Booking no. {booking}-id Canceled - {airports} of {departure}-date",
                "subject-refuse": "Booking no. {booking}-id Canceled - {airports} of {departure}-date",
                "subject-refuse-single": "Booking no. {booking}-id Canceled - {airports} of {departure}-date",
                "header-cancel": "Cancelled reservation request",
                "header-refuse": "Cancelled reservation request",
                "header-refuse-single": "Cancelled reservation request",
                "greeting": "Dear member,",
                "explanation-cancel": "OpenFly canceled your booking request for the following trip:",
                "explanation-refuse": "OpenFly declined your booking request for the following trip:",
                "explanation-motif": "Stornierungsgrund : {motif}",
                "line_other_offer_waiting": "A pilot can still respond to your request.",
                "line_other_offers_waiting": "Your {waitingOffers} other choices can still answer your request",
                "line_estimate_waiting": "You still have an estimate waiting for a reply on this booking, you can review it again and answer it by clicking on the button below:",
                "link-estimate-button": "Check estimate",
                "line_all_choices_declined": "All of your selected pilots unfortunately declined your booking request.",
                "comment": "We are sorry for the inconvenience.<br>You can immediately start a new search to select new offers by clicking on the button below.",
                "link-button": "BOOK ANOTHER PLANE",
                "refund-info": "The funds for this booking are now available in your e-wallet. You can use them for another booking or <a href=\"{refundLink}\">make a withdrawal of funds</a>."
            },
            "booking-cancelled-by-pilot-to-owner": {
                "subject-cancel": "Booking no. {booking}-id Canceled - {airports} of {departure}-date",
                "subject-refuse": "Booking no. {booking}-id Declined - {airports} of {departure}-date",
                "header-cancel": "Booking Canceled<br><small><i>Booking n°: {number}</small>",
                "header-refuse": "Booking Declined<br><small><i>Booking n°: {number}</small>",
                "greeting": "Hello {firstname} {lastname}",
                "explanation": "The booking request on your plane <b>{plane}-model</b>, registered <b>{plane}-number</b> was cancelled by the pilot {pilot} for the following reason: \"{motif}\".",
                "comment": "Our team has notified the client."
            },
            "booking-cancelled-by-owner-to-pilot": {
                "subject": "Booking no. {booking}-id Canceled - {airports} of {departure}-date",
                "greeting": "Hello {firstname} {lastname}",
                "explanation_individual": "The booking request listed below, for {firstname} was declined by the owner for the following reason: \"{motif}\".",
                "explanation_professional": "The booking request listed below, for {entity} was declined by the owner for the following reason: \"{motif}\".",
                "comment": "We send an email to inform the booking company."
            },
            "booking-cancelled-by-owner-to-member": {
                "subject-cancel": "Booking no. {booking}-id Canceled - {airports} of {departure}-date",
                "subject-refuse": "The owner of one of your selected aircrafts declined the booking for a {airports} trip",
                "subject-refuse-single": "The owner of the selected aircraft declined the booking for a {airports} trip",
                "header-cancel": "Cancelled reservation<br><small><i>Booking n°: {number}</small>",
                "header-refuse": "Request refused by owner<br><small><i>Booking n°: {number}</small>",
                "greeting": "Hello {firstname} {lastname},",
                "explanation-cancel": "The plane's owner canceled your booking request for the following trip:",
                "explanation-refuse": "The plane's owner declined your booking request for the following trip:",
                "line_reason": "The owner selected the following reason: \"{motif}\"",
                "line_other_offer_waiting": "A owner can still respond to your request.",
                "line_other_offers_waiting": "Your {waitingOffers} other choices can still answer your request",
                "line_estimate_waiting": "You still have an estimate waiting for a reply on this booking, you can review it again and answer it by clicking on the button below:",
                "link-estimate-button": "Check estimate",
                "line_all_choices_declined": "All of your selected pilots unfortunately declined your booking request.",
                "comment": "We are sorry for this inconvenience.<br>You can immediately start a new search to select new offers by clicking on the button below.",
                "link-button": "BOOK ANOTHER PLANE",
                "view-booking-button": "See booking details",
                "refund-info": "The funds for this booking are now available in your e-wallet. You can use them for another booking or <a href=\"{refundLink}\">make a withdrawal of funds</a>."
            },
            "booking-canceled-by-entity-to-passengers": {
                "subject": "Booking no. {booking}-id Canceled - {airports} of {departure}-date",
                "header": "Booking canceled<br><small><i>Booking n°: {number}</small>",
                "greeting": "Hello {firstname} {lastname},",
                "explanation_entity": "The following booking has been canceled today by {user}-first-name {user}-last-name for the following reason: \"{reason}\"",
                "explanation_entity_without_reason": "The following booking has been canceled today by {user}-first-name {user}-last-name",
                "explanation_nautics": "The shared booking below, which you joined, was canceled today by {entity}-name for the following reason: \"{reason}\""
            },
            "booking-canceled-by-entity-to-pilot": {
                "subject": "Booking no. {booking}-id Canceled - {airports} of {departure}-date",
                "greeting": "Hello {firstname} {lastname},",
                "explanation-professional": "The following booking, aboard a {plane}-model, registrated {plane}-immat, was canceled today by {entity}-name for the following reason: \"{reason}\"",
                "explanation-individual": "The following booking, aboard a {plane}-model, registrated {plane}-immat, was canceled today by {firstname} {lastname} for the following reason: \"{reason}\"",
                "comment": "The owner has been informed by email of this cancellation.",
                "warning": "As per our terms and conditions, you can request that the client pays cancellation fees up to {percentage}% of your pilot services, which amounts to {amount} €.",
                "contact-needed": "If needed, you can contact the client:"
            },
            "booking-canceled-by-entity-to-owner": {
                "subject": "Booking no. {booking}-id Canceled - {airports} of {departure}-date",
                "header": "Booking canceled<br><small><i>Booking n°: {number}</small>",
                "greeting": "Hello {firstname} {lastname},",
                "explanation-individual": "The following booking, aboard your plane {plane}-model, registered {plane}-immat, was canceled today by {firstname} for the following reason: \"{reason}\"",
                "explanation-professional": "The following booking, aboard your plane {plane}-model, registered {plane}-immat, was canceled today by {entity}-name for the following reason: \"{reason}\"",
                "explanation_airline-individual": "The following booking, aboard your plane {plane}-model, registered {plane}-immat, was canceled today by {firstname} for the following reason: \"{reason}\"",
                "explanation_airline-professional": "The following booking, aboard your plane {plane}-model, registered {plane}-immat, was canceled today by {entity}-name for the following reason: \"{reason}\"",
                "comment": "The pilot has been informed by email of this cancellation.",
                "warning": "As per our terms and conditions, you can request that the client pays cancellation fees up to {percentage}% of your plane's rental fees, which amounts to {amount} €.",
                "warning_airline": "As per our terms and conditions, you can request that the client pays cancellation fees up to {percentage}% of your total invoice, which amounts to {amount} €.",
                "contact-needed": "If needed, you can contact the client:"
            },
            "booking-entity": {
                "subject": "Booking Request Registered - From {airport} on {date}",
                "header": "Booking Request Registered<br><small><i>Booking number n°: {number}</small>",
                "title": "Booking Request Registered",
                "greeting": "Hello {firstname} {lastname},",
                "info-when-accepted": "As soon as the pilot accepts your request, you will receive his full contact details.",
                "explanation-1-choice": "Your booking request listed above, for a flight departing from {departure}-airport on {departure}-date aboard plane {plane}-model was send to your pilot for confirmation.",
                "explanation-multiple-choices": "Your booking listed above, departing from <b>{departure}-airport</b> on <b>{departure}-date</b> has been sent for validation to the pilots you selected:",
                "contact-needed": "We will notify you as soon as the pilot answers your request",
                "comment": "Have a nice day!",
                "salutation": "The OpenFly team",
                "amount-to-wire": "Amount to transfer to your OpenFly wallet: <b>{amount}</b><br><b>IBAN: </b>{iban}&nbsp;&nbsp;&nbsp;<b>BIC: </b>{bic}",
                "zero-emission-info": "You have selected a <b>zero-emission</b> aircraft. Once the flight is completed, your contribution will be paid to the Aero4good association, which will redistribute it to partner training schools to encourage the use of electric aircraft, thereby avoiding the emission of the same quantity of CO2. <b>In return, you will receive a carbon offset certificate and a receipt for the payment of the funds.</b>"
            },
            "booking-contact-us": {
                "subject": "Nouvelle demande de multi-leg ou aller simple",
                "greeting": "Bonjour,",
                "intro": "Une nouvelle demande de multi-leg ou aller simple a été effectué par le client suivant",
                "lastname": "Nom",
                "firstname": "Prénom",
                "email": "Adresse email",
                "phone": "Téléphone",
                "entity": "Entreprise",
                "for-passengers": "Passagers"
            },
            "booking-contact-us-offers": {
                "subject": "Demande d'assistance",
                "greeting": "Demande d'assistance",
                "intro": "Une nouvelle demande d'assistance a été effectuée",
                "nb_passengers": "Flight request for 1 passenger|Flight request for: no. of passengers"
            },
            "booking-contact-us-offers-to-user": {
                "subject": "Request for quotation registered",
                "greeting": "Dear Member,",
                "description": "Your request for a quote has been processed for a departure from {airport} on {departure}.",
                "description2": "We will get back to you as soon as possible."
            },
            "new-subscription": {
                "subject": "Souscription d'un nouvel adhérent",
                "greeting": "Bonjour",
                "intro": "Une nouvelle demande de souscription a été effectuée, recevoir une facture pour payer plus tard.",
                "intro-paymentByCard": "Une nouvelle souscription a été effectuée, avec un paiement par carte."
            },
            "new-user-password-init": {
                "subject": "Create your OpenFly password",
                "greeting": "Hello {firstname} {lastname},",
                "intro": "<b>{adminfirstname} {adminlastname}</b> created your user account on OpenFly for company <b>{entity}</b>.",
                "comment": "To complete your account creation and start booking flights, please <b>create your password</b> by clicking the link below:",
                "create-password": "Create my password"
            },
            "new-other-user-password-init": {
                "subject": "Welcome to OpenFly !",
                "greeting": "Hello {firstname} {lastname},",
                "intro": "To complete your account's creation, please create your password by clicking on the button below:",
                "intro-pilot": "To complete your account's creation, and offer your services to the Club OpenFly Members, please create your password by clicking on the button below:",
                "intro-owner": "To complete your account's creation, and offer your plane to the Club OpenFly Members, please create your password by clicking on the button below:",
                "intro-pilot-owner": "To complete your account's creation, and offer your services and your plane to the Club OpenFly Members, please create your password by clicking on the button below:",
                "intro-company": "To complete your account's creation, and offer your fleet and crews to the Club OpenFly Members, please create your password by clicking on the button below:",
                "comment": "As a reminder, here is your username to log in to your account: <strong> {email} </strong>",
                "create-password": "Create my password"
            },
            "change-email": {
                "subject": "Email Address Modification",
                "greeting": "Email Address Modification",
                "explanation": "You requested to change the email address linked to your OpenFly account.<br>To confirm this change, please click the button below.<br><br>The link will stay active for 24h. After this delay, please repeat your request.",
                "link-button": "Confirm my email address"
            },
            "new-request-authorization": {
                "subject": "New authorization request for plane {plane}",
                "greeting": "New Authorization Request",
                "explanation": "A pilot has requested your authorization to fly your plane <b>{plane}</b><br /><br />Please find below the pilot's details:",
                "link-button": "Manage authorizations"
            },
            "deleted-request-authorization": {
                "subject": "Authorization on plane {plane} deleted by pilot",
                "greeting": "Authorization deleted",
                "explanation": "An Authorization for your plane <b>{plane}</b> has been removed by the pilot.<br /><br />Below are the contact details of the pilot who made the request :"
            },
            "new-rex-to-pilot": {
                "subject": "A pilot has shared a new flight feedback",
                "greeting": "Hello {firstname},",
                "explanation": "A pilot has shared a feedback, following a flight {legs}.<br><br>Click on the button below to view it:",
                "link-button": "See the feedback"
            },
            "request-authorization-accepted": {
                "subject": "Authorization for plane {plane} granted",
                "subject-first": "First authorization granted",
                "greeting": "Authorization Request Granted",
                "greeting-first": "First authorization granted",
                "explanation": "We are pleased to announce that your clearance has been accepted by the owner of the {planeModel} {registrationNumber}, and validated by our services.<br>Attached is <b>a guide to best practice</b> on the platform.<br /><br />Please find below the owner's details:",
                "explanation-first": "We are pleased to announce that your clearance has been accepted by the owner of the {planeModel} {registrationNumber}, and validated by our services. You will now be able to offer your piloting services to OpenFly Premium members.<br>Attached is a guide to best practice on the platform.<br /><br />Please find below the owner's details:",
                "link-button": "New authorization request",
                "calendar-sync-intro": "OpenFly allows you to synchronise your calendar with OpenFly's calendar. All your confirmed bookings will appear in you calendar, including your passengers contact information.",
                "calendar-sync-guide-download": "Download the synchronisation guide for iPhone or Android by clicking one of the following links:",
                "guide-info": "Attached is a guide to best practice on the platform."
            },
            "request-authorization-refused": {
                "subject": "Authorization Request on plane {plane} declined",
                "greeting": "Authorization Request Declined",
                "explanation": "Your authorization request for plane <b>{plane}</b> Was declined by the owner.<br /><br />Please find below the owner's details:",
                "link-button": "New authorization request"
            },
            "authorization-cancelled": {
                "subject": "Authorization for plane {plane} revoked",
                "greeting": "Authorization Revoked",
                "explanation": "Your authorization to fly on <b>{plane}</b> was revoked by the owner.<br /><br />Please find below the owner's details:",
                "link-button": "New authorization request"
            },
            "media-expiration": {
                "subject": "\tYour {documentName} will expire in {delay}",
                "greeting": "Hello {firstname} {name},",
                "text": "<p>You uploaded your {documentName} to your OpenFly account. This document will expire on  {expirationDate}.<br><br>\n        In order to keep your profile up to date, and ensure you stay visible on the platform, please upload your new {documentName} to your profile.<br><br>",
                "button": "UPDATE MY PROFILE"
            },
            "booking-pilot-passenger-join": {
                "subject-plural": "New passengers participate in your flight {trips}",
                "subject-singular": "A new passenger participates in your flight {trips}",
                "header-plural": "New passengers participate in your flight",
                "header-singular": "A new passenger participates in your flight",
                "greeting": "Hello {firstname} {name},",
                "trip-details-individual-singular": "A new passenger participates in your flight from {date} from {departure}",
                "trip-details-professional-singular": "New passengers participate in your flight from {date} from {departure}",
                "trip-details-individual-plural": "A new passenger participates in your flight from {date} from {departure}",
                "trip-details-professional-plural": "New passengers participate in your flight from {date} from {departure}",
                "button": "See details",
                "total-weight": "Total weight : {weight}",
                "passengers": "<font size=\"5\"><b>The passengers :</b></font>",
                "empty-seats": "{seats} available seat|{seats} available seats"
            },
            "booking-entity-passenger-cancelled": {
                "subject": "Cancellation of taking charge of a passenger",
                "greeting": "Hello {firstname} {lastname},",
                "text": "The passenger {firstname} {lastname} wanted to join your flight above. The pilot declined to take charge of this passenger.",
                "trip-details": "A passenger has been removed from your flight from {departure} on {date}."
            },
            "booking-entity-passenger-join": {
                "subject-plural": "A new passenger has joined your trip {trips}",
                "subject-singular": "New passengers have joined your trip {trips}",
                "header-plural": "New passengers for your trip",
                "header-singular": "New passenger for your trip",
                "greeting": "Hello {firstname} {name},",
                "trip-details-singular": "A new passenger has joined your flight on {date} departing from {departure}.",
                "trip-details-plural": "New passengers have joined your flight on {date} departing from {departure}.",
                "button": "See more details"
            },
            "booking-entity-passenger-join-cancelled": {
                "subject": "Canceled Booking",
                "greeting": "Hello {firstname} {lastname},",
                "explanation": "The participation in the flight from <b>{departure}-airport on {departure}-date</b> aboard the plane <b>{plane}-model</b> was declined by the pilot for the following passenger:",
                "contact-pilot": "We invite you to contact the pilot for more information:",
                "sorry": "We are sorry for the inconvenience.",
                "button": "Search for a new plane"
            },
            "booking-user-join-shared": {
                "subject": "Join this flight for free {trips}",
                "header": "Join this flight for free",
                "greeting": "Hello {firstname} {name},",
                "text-trip": "An OpenFly member has shared {seats} seat for a {departure} - {arrival} flight on {date}.|An OpenFly member has shared {seats} seats for a {departure} - {arrival} flight on {date}.",
                "text-join": "Your Nautics balance is {nauticsBalance}. As a member of Club OpenFly, you can join this flight for free, using your Nautics.",
                "text-detail": "Here are the flight details:</p>",
                "button": "Join this flight"
            },
            "booking-user-missing-wallet-funds": {
                "subject": "Your electronic wallet is not funded for your flight {trips}",
                "greeting": "Hello {firstname},",
                "line1": "Your electronic wallet is not funded for your flight {departure} - {arrival} on the {date}.",
                "line2": "You can load it again from your wallet page:",
                "action": "Access my wallet"
            },
            "booking-passenger-join-shared": {
                "subject": "Join this flight {trips}",
                "header": "Join this flight",
                "greeting": "Hello {firstname} {name},",
                "text-trip": "A member of the OpenFly Premium Club shared {seats} seats for a {departure} - {arrival} on {date}.",
                "text-detail": "Here are the details of the flight:</p>",
                "join-instructions-individual": "To participate in this flight for free, we invite you to contact {firstname}, where you are identified as a passenger.",
                "join-instructions-professional": "To participate in this flight for free, we invite you to contact the company {passenger_entity}, where you are identified as a passenger.",
                "unsubscribe-link": "To stop receiving these emails, click <a id=\"unsubscribe-link\" href=\"{target}\">here</a>."
            },
            "booking-pilot-missing-wallet-funds": {
                "subject-1-days": "The sponsor's electronic wallet is not funded with the supplement requested by your proposal for the flight {trips}",
                "subject-3-days": "The sponsor's electronic wallet is not funded for the flight {trips}",
                "greeting": "Hello {firstname},",
                "line1-1-days": "The sponsor's electronic wallet is not funded with the supplement requested by your proposal for the flight {departure} - {arrival} on the {date}.",
                "line1-3-days": "The sponsor's electronic wallet is not funded for the flight {departure} - {arrival} on the {date}."
            },
            "booking-support-missing-wallet-funds": {
                "subject-2-days": "The sponsor's ({entityName}) electronic wallet is not funded for the flight {trips}",
                "greeting": "Hello,",
                "line1-2-days": "The sponsor's ({entityName}) electronic wallet is not funded for the flight {departure} - {arrival} on the {date} with {pilotName}."
            },
            "plane-calendar-reminder": {
                "subject": "Your calendar hasn't been updated in 15 days",
                "greeting": "Your calendar hasn't been updated in 15 days",
                "explanation": "The availabilities for your plane registered {immatriculation} haven't been updated in 15 days. Letting Club OpenFly Members know when your plane is available is paramount to ensure they can use your services for their business trips.<br /><br />\n        To make things easier, we allow you to sync your calendar from your smartphone to the platform:<br /><br />\n        <a href=\"https://www.openfly.fr/files/fr/ios-owners-pilots.pdf\">Sync with iOS</a>\n        <br />\n        <a href=\"https://www.openfly.fr/files/fr/android-owners-pilots.pdf\">Sync with Android</a>\n        <br /><br />\n        You can also fill in your availabilities from your OpenFly account.",
                "link-button": "Update my calendar",
                "link-button-2": "My calendar is up-to-date"
            },
            "pilot-calendar-reminder": {
                "subject": "Your calendar hasn't been updated in 15 days",
                "greeting": "Your calendar hasn't been updated in 15 days",
                "explanation": "Your OpenFly availabilities haven't been updated in 15 days. Letting Club OpenFly Members know when you are available is paramount to ensure they can use your services for their business trips..<br /><br />\n        To make things easier, we allow you to sync your calendar from your smartphone to the platform:<br /><br />\n        <a href=\"https://www.openfly.fr/files/fr/ios-owners-pilots.pdf\">Sync with iOS</a>\n        <br />\n        <a href=\"https://www.openfly.fr/files/fr/android-owners-pilots.pdf\">Sync with Android</a>\n        <br /><br />\n        You can also fill in your availabilities from your OpenFly account.",
                "link-button": "Update my calendar",
                "link-button-2": "My calendar is up-to-date"
            },
            "booking-reminder-v2-unanswered24h": {
                "subject": "Unanswered Booking",
                "greeting": "Unanswered Booking",
                "explanation": "Hello <br><br>\n        The following booking request n° {booking_id} for a flight on {booking_flight_date} at {booking_flight_time} didn't receive an answer.<br />\n        Pilot : {pilote_name}.<br />",
                "link-button": "See booking details"
            },
            "prices-table-htmlable": {
                "calc-detail": "Calculation detail:",
                "price-table-plane-routing": "Bareboat plane rental - routing",
                "price-table-plane-non-routing": "Bareboat plane rental - flight",
                "price-table-plane-immobilization": "Bareboat plane rental - immobilization",
                "price-table-plane-nights": "Bareboat plane rental - nights",
                "price-table-plane-setup": "Bareboat plane rental - setup",
                "price-table-plane-plane-flight": "Bareboat plane rental - flight",
                "price-table-plane-min-day": "Bareboat plane rental - min rate compensation",
                "price-table-plane-tax": "Airport taxes",
                "price-table-plane-handling-tax": "Bareboat plane rental - handling fee",
                "price-table-pilot-routing": "Pilotage service - routing",
                "price-table-pilot-non-routing": "Pilotage service - flight",
                "price-table-pilot-immobilization": "Pilotage service - immobilization",
                "price-table-pilot-nights": "Pilotage service - nights",
                "price-table-pilot-setup": "Pilotage service - setup",
                "price-table-pilot-plane-flight": "Pilotage service - flight",
                "price-table-pilot-min-day": "Pilotage service - min rate compensation",
                "price-table-pilot-tax": "Airport taxes",
                "price-table-pilot-daily": "Professional pilot service",
                "price-table-pilot-handling-tax": "Handling fee",
                "price-table-pilot-additional-charges": "Additional charges",
                "price-table-owner-additional-charges": "Additional charges",
                "price-table-plane-additional-charges": "Additional charges"
            },
            "registration-complete": {
                "subject": "Welcome to Club OpenFly!",
                "greeting": "Welcome to Club OpenFly!",
                "explanation": "You just subscribed to Club OpenFly, and are now a member!<br>More than 120 planes are now available to plan your trips!<br /><br />\n        Your account will be fully activated in two business days. In the meantime, you can already access the platform, look at the available airplanes, and the estimates. As soon as your account is activated, you'll be able to book flights and plan your trips.<br><br>\n        <b>To finish creating your account</b>, please <b>create your password</b> by clicking on the button below:<br />",
                "link-button": "Create my password",
                "detail": "As a reminder, <b>here is your user name</b> to log in to your account: {email}",
                "privacy": "All the data you will fill in on our website <a href=\"www.openfly.fr\">www.openfly.fr</a> are protected with a secure access and will stay strictly private."
            },
            "registration-demo-complete": {
                "subject": "Welcome to your trial of Club OpenFly!",
                "greeting": "Welcome to your trial of Club OpenFly!",
                "explanation": "You can now try all Club OpenFly services for free for a period of 3 days. You can already use the platform, view all destinations and planes, and all price estimates.\n        <br /><br />\n        <b>To finish creating your account</b>, please <b>create your password</b> by clicking on the button below:\n        <br />",
                "link-button": "Create my password",
                "detail": "As a reminder, <b>here is your user name</b> to log in to your account: {email}",
                "privacy": "All the data you will fill in on our website <a href=\"www.openfly.fr\">www.openfly.fr</a> are protected with a secure access and will stay strictly private."
            },
            "registration-complete-without-password": {
                "subject": "Welcome to Club OpenFly!",
                "greeting": "Welcome to Club OpenFly!",
                "explanation": "You just subscribed to Club OpenFly, and are now a member ! More than 120 planes are now available to plan your trips!<br /><br />\n        Your account will be fully activated in two business days. In the meantime, you can already access the platform, look at the available airplanes, and the estimates. As soon as your account is activated, you'll be able to book flights and plan your trips.<br><br>",
                "link-button": "Book a flight",
                "detail": "As a reminder, <b>here is your user name</b> to log in to your account: {email}",
                "privacy": "All the data you will fill in on our website <a href=\"www.openfly.fr\">www.openfly.fr</a> are protected with a secure access and will stay strictly private."
            },
            "confirm-email": {
                "subject": "Last step to activate your account",
                "greeting": "Hello,",
                "line_1": "Thank you for creating an account on OpenFly.",
                "line_2": "To confirm your e-mail address and complete your registration, please click on the following link:",
                "line_3": "If you encounter any difficulties, please do not hesitate to contact us on {phoneNumber}.",
                "link-button": "Confirm my e-mail",
                "salutation": "<br>See you soon.<br><br>Best regards,<br>The OpenFly team"
            },
            "welcome-email": {
                "subject": "Welcome among our members",
                "greeting": "Dear member,",
                "line_1": "The entire OpenFly team joins me in welcoming you to our membership.",
                "line_2": "At OpenFly, we believe that you should be able to move efficiently, wherever you are, with propeller aircrafts that emit 3 to 4 times less CO2 than jets.",
                "line_3": "You can now discover our connecting platform and make your travel simulations at attractive rates.",
                "line_4": "If needed, please contact me at {phoneNumber}.",
                "link-button": "Start searching",
                "salutation": "See you soon.<br><br>Best regards,<br>Lolita Vigouroux<br><br><div style=\"text-align: center; margin-left: auto; margin-right: auto;\"><table><tr><td><img src=\"https://dev.openfly.fr/imgs/customer-manager.jpeg\" alt=\"Customer Manager\" style=\"max-width: 90%; width: 800px;\" /></td></tr></table></div>"
            },
            "pilot-monthly-reporting": {
                "subject": "OpenFly - Pilot activity summary - {month} {year}",
                "greeting": "Hello {firstname} {lastname},",
                "intro": "Here is a summary of your activity on OpenFly for {month} {year}.",
                "visit-dashboard": "Access your dashboard",
                "your-visibility": "<h2 style=\"font-size: 24px;\">Your visibility</h2>",
                "your-activity": "<h2 style=\"font-size: 24px;\">Your activity</h2>",
                "actions-to-perform": "<h2 style=\"font-size: 16px; margin-bottom: 0;\">Actions to perform</h2>",
                "visibility": {
                    "listing-count": "Listings in the listing",
                    "avg-position": "Average position",
                    "detail-opening-count": "Detail page openings"
                },
                "activity": {
                    "booking-request-count": "Booking requests",
                    "confirmed-booking-request-count": "Confirmed booking requests",
                    "unconfirmed-booking-request-count": "Unconfirmed booking requests",
                    "declined-booking-request-count": "Declined booking requests",
                    "flight-count": "Flights made",
                    "earnings": "Earnings of realized flights",
                    "missed-earnings": "Earnings of rejected flights"
                },
                "actions": {
                    "offers-to-confirm": "{1}{count} booking request to confirm|[2,*]{count} booking requests to confirm",
                    "offers-to-validate": "{1}{count} flight to validate|[2,*]{count} flights to validate",
                    "update-calendar": "{-1} Update your calendar <small><i>(never updated)</i></small>|Update your calendar <small><i>({nbDays} days without update)</i></small>",
                    "update": "Update",
                    "add-profile-picture": "Add a photo",
                    "add": "Add",
                    "confirm": "Confirm",
                    "validate": "Validate",
                    "complete": "Complete",
                    "complete-description": "Complete description"
                }
            },
            "plane-monthly-reporting": {
                "subject": "OpenFly - Plane activity summary - {month} {year}",
                "greeting": "Hello {firstname} {lastname},",
                "intro": "Here is a summary of the activity of your plane {immatriculation} on OpenFly for {month} {year}.",
                "visit-dashboard": "Access your dashboard",
                "your-visibility": "<h2 style=\"font-size: 24px;\">Your visibility</h2>",
                "your-activity": "<h2 style=\"font-size: 24px;\">Your activity</h2>",
                "recent-flight-planes": "<h2 style=\"font-size: 24px;\">Recent flight planes</h2>",
                "actions-to-perform": "<h2 style=\"font-size: 24px;\">Actions to perform</h2>",
                "visibility": {
                    "listing-count": "Listings in the listing",
                    "avg-position": "Average position",
                    "detail-opening-count": "Detail page openings"
                },
                "activity": {
                    "booking-request-count": "Booking requests",
                    "confirmed-booking-request-count": "Confirmed booking requests",
                    "unconfirmed-booking-request-count": "Unconfirmed booking requests",
                    "declined-booking-request-count": "Declined booking requests",
                    "flight-count": "Flights made",
                    "earnings": "Earnings of realized flights",
                    "missed-earnings": "Earnings of rejected flights"
                },
                "actions": {
                    "habilitations-to-confirm": "Demandes d'habilitations <small><i>({demandes} demandes)</i></small>",
                    "update-calendar": "{-1} Calendar update <small><i>(never update)</i></small>|Calendar update <small><i>({nbDays} days without action)</i></small>",
                    "update": "Update",
                    "answer-habilitation-requests": "Reply",
                    "add": "Add",
                    "complete": "Complete",
                    "complete-description": "Complete description",
                    "add-pictures": "Add photos"
                }
            },
            "booking-passenger-time-updated": {
                "subject": "Times changed for your flight from: departure on {departureDate}",
                "header": "Times changed for your flight",
                "greeting": "Hello {user},",
                "explanation": "Your flight schedule from {departure} of {departureDate} have been changed :\n            <br><br>",
                "schedule-changed": "Modified schedule : ",
                "detail": "As a reminder, <b> here is your username </b> to login to your account: {email}"
            },
            "booking-owner-time-updated": {
                "subject": "Schedule changed for the flight from {departure} on {departureDate} on your plane {immatriculation}",
                "header": "Schedule changed for the flight on your plane",
                "greeting": "Hello {user}",
                "explanation": "Flight schedules from {departure} of {departureDate} aboard your plane {immatriculation} have been modified by the sponsor: <br><br>",
                "schedule-changed": "Modified schedule : ",
                "detail": "As a reminder, <b> here is your username </b> to login to your account: {email}"
            },
            "booking-pilot-time-updated": {
                "subject": "Times changed for your flight from {departure} on {departureDate}",
                "header": "Times changed for your flight",
                "greeting": "Hello {user}",
                "explanation": "Your flight departures from {departureDate} have been modified by the sponsor :\n            <br><br>",
                "schedule-changed": "Modified schedule : "
            },
            "booking-pilot-passengers-updated": {
                "subject": "Modified passengers for your flight from {departure} on {departureDate}",
                "header": "Modified passengers",
                "greeting": "Hello {firstname},",
                "trip-details": "the passengers of your flight from {departure} on {departureDate} have been modified by the sponsor:",
                "button": "Booking details"
            },
            "booking-owner-passengers-updated": {
                "subject": "Modified passengers for the flight from {departure} on {departureDate} on your plane {immatriculation}",
                "header": "Modified passengers",
                "greeting": "Hello {firstname},",
                "trip-details": "he passengers of the flight from {departure} on {departureDate} aboard your plane {immatriculation} have been modified by the sponsor:",
                "button": "Booking details"
            },
            "booking-passenger-added": {
                "subject": "You have been added on the flight from {departure} on {departureDate}",
                "greeting": "Hello {firstname},",
                "trip-details": "{userFirstname} {userLastname} added you to the flight from {departure} on {departureDate}, here are the details:"
            },
            "booking-passenger-removed": {
                "subject": "You have been removed on the flight from {departure} on {departureDate}",
                "greeting": "Hello {firstname},",
                "trip-details": "{userFirstname} {userLastname} removed you from the flight at departure from {departure} on {departureDate}, dhere are the details:"
            },
            "contract-member": {
                "subject": "Validate your Club Premium contract",
                "link-button": "Read and validate the contract"
            },
            "contract-confirmation-member": {
                "subject": "Your contract for the OpenFly Premium Club",
                "greeting": "Dear {firstname},",
                "explanation": "The whole OpenFly team joins me in welcoming you among our members. I'm currently opening your Premium access in order to let you book trips.\n        <br /><br />\n        You will now be able to:\n        <br /><br />",
                "thanks": "Merci de votre confiance",
                "thumbnails": {
                    "pilot_acces": "Contact the professional pilots and book the private planes we list",
                    "airline_acces": "Have unlimited access to our partner airlines",
                    "free_seat": "Join the free seats on other member's shared flights thanks to Nautics"
                },
                "contract": "You'll find your subscription contract attached to this email.",
                "salutation": "At your disposal,<br>Lolita from OpenFly"
            },
            "contract-confirmation-support": {
                "subject": "New Premium club member",
                "greeting": "Hello,",
                "explanation-individual": "A new member just registered to the Premium club:\n        <br /><br />\n        <ul>\n            <li>First name: {firstName}</li>\n            <li>Last name: {lastName}</li>\n            <li>Individual</li>\n        </ul>\n        <br /><br />",
                "explanation-professional": "A new member just registered to the Premium club:\n        <br /><br />\n        <ul>\n            <li>First name: {firstName}</li>\n            <li>Last name: {lastName}</li>\n            <li>Entity: {entityName}</li>\n        </ul>\n        <br /><br />",
                "link": "See profile"
            },
            "booking-prospect-join-shared": {
                "subject": "Join this trip: {trips}",
                "header": "Join this trip",
                "greeting": "Dear member,",
                "text-trip": "We wanted to let you know one of an OpenFly Premium member <b>shared {seats} seat for a {trips} flight</b>, on {date}.|We wanted to let you know one of the Club OpenFly members shared {seats} seats for a {trips} flight, on {date}.",
                "explanation": "By joining the Premium Club, you can join this trip for free!",
                "button": "Subscribe",
                "salutation": "<br>Best Regards,",
                "before-footer-text": "You receive this mail from OpenFly"
            },
            "leg-taxes-to-pilot": {
                "subject": "{airportName} airport entered the taxes amount for the {flightLegs} booking request",
                "header": "{airportName} airport entered the taxes amount",
                "greeting": "Hi {firstname},",
                "text-trip": "{airportName} airport entered the taxes amount for booking request number {bookingNumber}:",
                "text-airport-taxes": "Taxes entered by the airport: {amount}",
                "button": "See detail"
            },
            "leg-taxes-to-support": {
                "subject": "The airport {airportName} has changed the taxes amount",
                "greeting": "Hello,",
                "text-trip": "The airport {airportName} has changed the taxes amount for booking {bookingNumber}:"
            },
            "plane-prices-change-to-pilots": {
                "subject": "Price modification for {model}, registration number {immatriculation}",
                "greeting": "Hello {firstname},",
                "explanation": "The owner of the <b>{model}</b>, registered <b>{immatriculation}</b> has changed the prices of the plane, on which you are authorized to fly.<br />Here are the prices the owner applied to date:",
                "explanation-support": "The owner of the <b>{model}</b>, registered <b>{immatriculation}</b> has changed the prices of the plane.<br />Here are the prices the owner applied to date:",
                "view": "View"
            },
            "plane-prices-htmlable": {
                "tarifHeure": "Hour rate (€)",
                "tarifHeureNonVolee": "Price hour not flown (€)",
                "nbMinutesMinimumJournee": "Minimum minutes day (mn)",
                "prixImmobilisation": "Immobilization price (€)",
                "tarifAcheminement": "Price routing (€)",
                "min_price_day": "Minimum price by day (€)",
                "not_specified": "Not specified"
            },
            "booking-summary-support": {
                "subject": "Résa n° {bookingId} - Vol {flightType} {flightLegs} - {flightDates} - {subscriptionType}",
                "title-date": "du {start} au {end}",
                "greeting": "Nouvelle demande de réservation ",
                "subtitle": "Réservation n° {bookingId}",
                "user-bloc-title": "<h2>L’adhérent :</h2>",
                "user-bloc-description-individual": "La personne <b>{fullname}</b> vient d’effectuer une nouvelle demande de réservation pour le vol suivant :",
                "user-bloc-description-professional": "De la société <b>{userEntity}</b> vient d’effectuer une nouvelle demande de réservation pour le vol suivant :",
                "booking-offer-bloc-title": "<h1>Choix n° {choiceNumber}</h1>",
                "plane-bloc-title": "<h2>L’avion :</h2>",
                "owner-bloc-title": "<h2>Appartenant à :</h2>",
                "pilot-bloc-title": "<h2>Piloté par :</h2>",
                "estimation-bloc-title": "<h2>Détail de l’estimation :</h2>",
                "passengers-bloc-title": "<h2>Passagers du vol :</h2>",
                "action": "Voir la réservation",
                "model": "Model",
                "registration-number": "Immatriculation",
                "airport-reference": "Home airport"
            },
            "authorization-proposals-to-pilot-notification": {
                "subject": "Become authorized to fly this new nearby plane|Become authorized to fly these new nearby planes",
                "greeting": "Make an authorization request",
                "line_1": "Hello {pilot_full_name},",
                "line_2": "Following your registration on OpenFly, your contact {user_admin_full_name} proposes to submit your pilot profile to owners of nearby planes.",
                "planes": "<b>Planes</b>",
                "line_3": "We propose that you ask to be authorized on the following aircraft:|You’ll find below a list of planes that might interest you:",
                "line_4": "Moreover, we are actively looking for airplanes and pilots in Europe. Don’t hesitate to talk about us, or to send us the details or plane owners and professional pilots who would like to join Club OpenFly.",
                "line_5": "If need be, you can contact our support team at <a href=\"mailto:support@openfly.fr\">support@openfly.fr</a>, or on the phone at <a href=\"tel:+33252595959\">+33252595959</a>."
            },
            "pilot": {
                "prices-updated": {
                    "old-price": "Old price",
                    "new-price": "New price",
                    "tarifHeure": "Hourly rate (€)",
                    "tarifAcheminement": "Routing price (€)",
                    "tarifHeureAttente": "Immobilization price (€/day)",
                    "tarifNuite": "Night price (€)",
                    "daily_rate": "Daily rate (€)"
                }
            },
            "plane": {
                "list-for-authorization-proposals": {
                    "link": "Authorization request"
                },
                "prices-updated": {
                    "old-price": "Old price",
                    "new-price": "New price",
                    "tarifHeure": "Hour rate (€)",
                    "tarifHeureNonVolee": "Price hour not flown (€)",
                    "nbMinutesMinimumJournee": "Minimum minutes day (mn)",
                    "prixImmobilisation": "Immobilization price (€)",
                    "tarifAcheminement": "Price routing (€)",
                    "min_price_day": "Minimum price by day (€)",
                    "nightly_rate": "Nightly rate (€)",
                    "not_specified": "Not specified"
                }
            },
            "owner-warn-authorisations-pending": {
                "subject": "You have {count} pending authorization request|You have {count} pending authorization requests",
                "greeting": "Pending authorization request|Pending authorization requests",
                "line_1": "Dear Owner,",
                "line_2": "You registered your plane on Openfly’s platform.",
                "line_3": "We curate a list of qualified pilots <b>who could fly your plane</b>.",
                "line_4": "Some of them have sent you <b>authorization requests</b>, and it seems you haven’t answered them yet.",
                "line_5": "We invite you to log in to your Owner profile to accept or decline these requests.",
                "line_6": "The more pilots you authorize to fly your plane, <b>the more chances you’ll have to rent it</b>, and <b>optimize your return over investment</b>.",
                "line_7": "As a reminder, all pilots registered on OpenFly are professional, freelance pilots.",
                "action": "See all requests : {immatriculation}",
                "link": "Ask habilitation"
            },
            "search-not-completed": {
                "subject": "Resume your search \"{airports}\"",
                "header": "Resume your search",
                "greeting": "Dear Member,",
                "line": "You have started a booking for a trip that needs to be finalised.",
                "actionText": "Resume search",
                "options": {
                    "option_1": {
                        "text": "If you wish to resume your search, click on the button below:"
                    },
                    "option_2": {
                        "text": "If not, can you tell us why?",
                        "buttons": {
                            "price-idea": "I just wished to have an estimate",
                            "too-expensive": "The planes were too expensive",
                            "no-suitable-airplane": "I didn't find any suitable plane"
                        }
                    }
                }
            },
            "special-offer-expiration": {
                "subject": "The promotional offer on your plane will soon expire",
                "greeting": "Hello {firstname},",
                "explanation": "The promotional offer of -{percent}% that you have activated on your {brand} {model} registered {immatriculation} expires in {daysDelay} days.<br/><br/>You can now extend it, or leave it active without limit duration by removing the end date in your “Promotional Offers” interface.",
                "line1": "The {discount}% discount you created on your plane registered {registration} will expire in a week. To prolong it, click on the button below:",
                "action": "Prolong offer",
                "button": "Extend the offer"
            },
            "documents-expiring-pilot": {
                "period": {
                    "7D": "7 days",
                    "14D": "14 days",
                    "1M": "1 month"
                },
                "subject": "Your {documentName} expires in {period}|{count} documents expire in {period}",
                "greeting": "Hello {firstname},",
                "line_1": "Your document <strong>{documentName} will expire in {period}</strong>.|Your documents <strong>{documentName} expire in {period}</strong>.",
                "line_2": "We invite you to <strong>upload in your pilot profile a current version</strong> of that document.|We invite you to <strong>upload in your pilot profile a current version</strong> of these documents.",
                "line_3": "Once this document’s expiration date has passed, your <strong>pilot profile will be suspended</strong>, and Club members won’t be able to see you in the search results, or to book you for a trip.|Once theses documents expiration date has passed, your <strong>pilot profile will be suspended</strong>, and Club members won’t be able to see you in the search results, or to book you for a trip.",
                "line_4": "Click the button below to upload a current version of the document:|Click the button below to upload a current version of the documents:",
                "button": "Update the document|Update the documents"
            },
            "documents-expiring-plane": {
                "period": {
                    "1D": "tomorrow",
                    "7D": "in 7 days",
                    "14D": "in 14 days",
                    "1M": "in 1 month"
                },
                "subject": "Your {documentName} expires {period}|{count} documents expire {period}",
                "greeting": "Hello {firstname},",
                "line_1": "Your document {documentName} for your aircraft {model} {immatriculation} expires {period}.",
                "line_2": "Please go to your owner account or click on the following link to udpate it as soon as possible. ",
                "line_3": "Any current booking with a departure after the expiry date will be cancelled if you do not update it as soon as possible.",
                "line_4": "The pilot will no longer be able to accept bookings if you do not update it as soon as possible.",
                "button": "Udpate document|Udpate documents"
            },
            "profile-suspended-pilot": {
                "to-pilot": {
                    "subject": "Your OpenFly pilot profile has been suspended",
                    "greeting": "Hello {firstname},",
                    "line_1": "Your OpenFly <strong>pilot profile has been suspended</strong>, following the lack of update of one or more documents which have expired.",
                    "line_2": "Club members won’t be able to see you in their search results, or to <strong>book your for their business trips</strong>.",
                    "line_3": "To be visible again on our platform, we invite you to <strong>update the expired documents</strong> in your pilot profile.",
                    "button": "Update my profile"
                },
                "to-owner": {
                    "subject": "{pilotFullname}'s OpenFly profile has been suspended",
                    "greeting": "Hello {firstname},",
                    "line_1": "<strong>{pilotFullname}'s OpenFly pilot profile has been suspended</strong>, following the lack of update of one or more documents which have expired.",
                    "line_2": "Club members won’t be able to see him in their search results, or to <strong>book him for their business trips</strong>.",
                    "only_this_pilot": "<strong>Your plane {immatriculation} will also be hidden in the search results</strong>, since no pilot is currently authorized to fly it.|<strong>Your planes {immatriculation} will also be hidden in the search results</strong>, since no pilot is currently authorized to fly them.",
                    "line_3": "We invite you to contact the pilot to entice him to update his documents and re-enable his OpenFly pilot profile."
                }
            },
            "chat-message-passenger": {
                "subject": "New message for your flight departing from {city} on {date}",
                "header": "New message",
                "greeting": "Hi {passenger_firstname},",
                "explanation": "You received a new message regarding your flight departing from {departure}-airport, aboard the plane registered {plane}-number, on {departure}-date.",
                "line_3": "To read it, click the button below:",
                "action": "Read the message"
            },
            "chat-message-pilot": {
                "subject": "New message for your flight departing from {city} on {date}",
                "header": "New message",
                "greeting": "Hi {pilot_firstname},",
                "explanation": "You received a new message regarding your flight departing from {departure}-airport, aboard the plane registered {plane}-number, on {departure}-date.",
                "line_3": "To read it, click the button below:",
                "action": "Read the message"
            },
            "chat-message-user": {
                "subject": "New message for your flight departing from {city} on {date}",
                "header": "New message",
                "greeting": "Hi {user_firstname},",
                "explanation": "You received a new message regarding your flight departing from {departure}-airport, aboard the plane registered {plane}-number, on {departure}-date.",
                "line_3": "To read it, click the button below:",
                "action": "Read the message"
            },
            "chat-message-owner": {
                "subject": "New message for a flight on your plane registered {plane}-number",
                "header": "New message",
                "greeting": "Hi {owner_firstname},",
                "explanation": "You received a new message regarding a flight departing from {departure}-airport, aboard your plane registered {plane}-number, on {departure}-date.",
                "line_3": "To read it, click the button below:",
                "action": "Read the message"
            },
            "chat-messages-daily-resume-to-us": {
                "subject": "Summary of daily message exchanges",
                "line": "<strong> In the conversation {conversation}-type of the offer n°{booking}-offer-id :</strong>",
                "chatMessages": "<i>{prenom} {nom} ({user}-id) sent a message :</i><br/>{text}"
            },
            "sponsorship-to-known-user": {
                "subject": "{firstname} {lastname} has refered you to join Club OpenFly!",
                "explanation": "{firstname} {lastname} invites you to join Club OpenFly!\n        <br><br>\n        As a Premium member of Club OpenFly, you’ll be able to access all the professional pilots and private planes registered on the platform.\n        <br><br>\n        Click the button below to join Club OpenFly Premium and earn 500 Nautics, which will allow you to travel for free using the free seats in the shared trips of the other Club members.",
                "button": "Join Club OpenFly"
            },
            "sponsorship-to-unknown-user": {
                "subject": "{firstname} {lastname} has refered you to join Club OpenFly!",
                "greeting": "Hello,",
                "explanation": "{firstname} {lastname} invites you to join Club OpenFly!\n        <br><br>\n        <b>OpenFly puts business aviation at your fingertips, and allows you to freely plan your trips using private planes and professional pilots.</b>\n        <br><br>\n        As a member of Club OpenFly, you’ll be able to rethink your professional travels, organizing multi-destination trips in one go or over multiple days, and by leaving, and landing as close as possible to your workplace or your home.\n        <br><br>\n        Click the button below to join Club OpenFly and earn 500 Nautics, which will allow you to travel for free using the free seats in the shared trips of the other Club members.",
                "button": "Join Club OpenFly"
            },
            "sponsorship-to-sponsor": {
                "subject": "{firstname} {lastname} subscribed to OpenFly following your sponsorship!",
                "explanation": "Your godchild {firstname_sponsored} {lastname_sponsored} became a Premium member of the OpenFly Club following your sponsorship!<br><br>\n        We have credited you with 1000 Nautics which will allow you to join the shared reservations of other Club members free of charge, and your godson has also been credited with 500 Nautics."
            },
            "sponsorship-to-support": {
                "subject": "{firstname} {lastname} a proposé un parrainage",
                "explanation": "Bonjour,<br><br>{sponsor} a envoyé une demande de parrainage à {filleul}."
            },
            "filtered-message-to-support": {
                "subject": "{sender}-fullname's message has been filtered",
                "explanation": "{sender}-fullname has attempted to send a message with the following information in OpenFly mailbox, which has been filtered:",
                "line_phone_number": "<b>Phone number</b>",
                "line_email_address": "<b>Email address</b>",
                "line_message_filtered": "This sending has been blocked (the information has been replaced by stars)."
            },
            "pilot-profile-completed-to-support": {
                "subject": "Le pilote {firstname} {lastname} a complété son profil",
                "explanation": "Bonjour,<br><br>Le pilote {firstname} {lastname} a complété son profil dans Nova.",
                "button": "Voir les détails"
            },
            "contract-sponsor-notification": {
                "subject": "{sponsored} a adhéré au Club OpenFly suite à un parrainage de {sponsoring}",
                "explanation": "Bonjour,<br><br>\n        {sponsored_user}, de l’entreprise {sponsored} a adhéré au Club OpenFly suite à un parrainage de l’entité {sponsoring}.\n        <br><br>\n        {sponsoring} a été créditée de 1000 Nautics\n        <br><br>\n        {sponsored} a été créditée de 500 Nautics, plus 750 Nautics pour s'être abonnée."
            },
            "booking-offers-confirmed-reminder": {
                "subject": "Validate your {departure_airport} -> {arrival_airport} flight on OpenFly",
                "greeting": "Dear pilot,",
                "line_1": "We hope your {departure_airport} -> {arrival_airport} flight on the {departure}-date went well.",
                "line_2": "All that remains is for you to validate the flight from your OpenFly pilot account.<br>By validating the flight, you tell us that it has taken place, which triggers the transfer of funds to your wallet and that of the owner.",
                "line_3": "Once the flight has been validated, you can let us know what you think of it, and possibly leave feedback for other pilots registered on OpenFly.",
                "button": "Validate flight"
            },
            "similar": {
                "title": "Here is a selection of planes that could match your search:",
                "button": "Book"
            },
            "counter-proposal-accepted-to-pilot": {
                "subject-individual": "{username} accepted your offer for flight {legs}",
                "subject-professional": "{entity} / {username} accepted your offer for flight {legs}",
                "header": "Proposal accepted",
                "greeting": "Hi {firstname}",
                "line": "{username} accepted your offer for the {legs} flight on {startdate}",
                "button": "See the details"
            },
            "counter-proposal-refused-to-pilot": {
                "subject": "A Club Member chose another pilot's proposition for their trip",
                "header": "Proposal refused",
                "greeting": "{firstname},",
                "line_professional": "For information, the company {entity} selected another proposal for their following trip:",
                "line_individual": "For information, {entity} selected another proposal for their following trip:",
                "button": "See the details"
            },
            "another-offer-selected-to-owner": {
                "subject": "A Member chose another pilot's proposition for their trip",
                "greeting": "{firstname},",
                "line_professional": "For information, the company {entity} selected another proposal for their following trip:",
                "line_individual": "For information, {entity} selected another proposal for their following trip:",
                "button": "See the details"
            },
            "counter-proposal-created-to-owner": {
                "subject": "New offer from the pilot to a member on your {plane}-registration aircraft",
                "greeting": "Hi {firstname},",
                "line_1": "The pilot {pilot}-fullname sent an offer to the client {entity} on your aircraft registered {plane}-registration, for the flight below:",
                "line_2": "You can look at the details of this offer by clicking on the button below:",
                "button": "See details"
            },
            "counter-proposal-refused-to-owner": {
                "subject": "Offer declined for a flight on your aircraft {plane}-registration",
                "header": "Offer declined",
                "greeting": "Hi {firstname},",
                "line_1": "The client {entity} declined the offer made by the pilot {pilot}-fullname on your aircraft registered {plane}-registration, for the flight below:"
            },
            "counter-proposal-created-to-member": {
                "subject": "You received a new estimate of your flight {legs}",
                "header": "You received a new estimate",
                "greeting": "Dear {firstname},",
                "line_1_single_choice": "{pilot}, {planeModel}'s pilot, sent you a new estimate of {totalPrice} for the following trip:",
                "line_1_multiple_choices": "{pilot}, {planeModel}'s pilot (Choice N°{choice}), sent you a new estimate of {totalPrice} for the following trip:",
                "line_2": "To review this new estimate, click the button below:",
                "button": "See the details",
                "line_3_single_choice": "This trip won’t be booked and confirmed until you accept this estimate.",
                "line_3_multiple_choices": "This trip won't be booked and confirmed until you accept this estimate, or another one from one of your other pilot choices.",
                "payment-delay-info": "You have <b>72 hours</b> to accept this proposal and make the pre-payment of the booking, otherwise <b>this proposal will be cancelled.</b>"
            },
            "counter-proposal-accepted-to-member": {
                "subject": "Information on your flight {legs}",
                "header": "Information on your flight",
                "greeting": "Hi {firstname},",
                "line": "Following the acceptance of the quote, please find, below, the contact details of your pilot:"
            },
            "new-rex-to-support": {
                "subject": "Nouveau REX de {pilot}",
                "line": "{pilot} a laissé un REX suite à son déplacement {tripAirport} du {departureDate}, avec le client {entity}.",
                "line_validation_needed": "Please validate it, so that it can be passed on to the other pilots.",
                "button": "Voir le rex"
            },
            "special-offer-nearby": {
                "subject": "Special offer: reduced price on the nearest airplane",
                "greeting_premium": "Dear Member,",
                "greeting_freemium": "Hello,",
                "line_1": "The owner of a nearby plane added a special offer on his aircraft, restricted to Premium OpenFly's members.",
                "line_discover": "This plane is now available to rent with a {percentage}% discount for your first travel!",
                "line_promo": "This plane is now available to rent with a {percentage}% discount if you book a trip during a period going from {startDate} to {endDate} !",
                "line_promo_noend": "This plane is now available to rent with a {percentage}% discount if you book a trip during a period start {startDate} !",
                "line_early": "This plane is now available to rent with a {percentage}% discount if you book a trip 45 days or more before its departure date!",
                "line_lastminute": "This plane is now available to rent with a {percentage}% discount is you book a trip 2 days or less before its departure date!",
                "line_fidelity": "This plane is now available to rent with a {percentage}% discount if you already flew Y times on this aircraft!",
                "line_delivery_exemption": "This plane is now available to rent with {delivery_exemption_time} minutes offered over the transit time!",
                "line_end_premium": "Login to OpenFly to take advantage of this special offer!",
                "line_end_freemium": "Login to OpenFly to learn more!",
                "action": "See plane"
            },
            "special-offer-nearby-v2": {
                "subject": "Special offer: plane {plane} near {airport}",
                "greeting_premium": "Dear Member,",
                "greeting_freemium": "Hello,",
                "line_1": "The owner of a nearby plane added a special offer on his aircraft, restricted to Premium OpenFly's members.",
                "line_1_multi": "The owner of a private aircraft located near you has put in place promotional offers on his aircraft, reserved for OpenFly Premium members.",
                "line_2": "<b>Here are the discounts you can benefit from:</b>",
                "line_2_single": "<b>Here are the discount you can benefit from:</b>",
                "line_discover": "&bull; <b>{percentage}% discount </b> for your first travel.",
                "line_promo": "&bull; <b>{percentage}% discount </b> if you book a trip during a period going from {startDate} to {endDate}.",
                "line_promo_noend": "&bull; <b>{percentage}% discount </b> if you book a trip during a period going from {startDate}",
                "line_early": "&bull; <b>{percentage}% discount </b> if you book a trip 45 days or more before its departure date.",
                "line_lastminute": "&bull; <b>{percentage}% discount </b> if you book a trip 2 days or less before its departure date.",
                "line_fidelity": "&bull; <b>{percentage}% discount </b> if you already flew Y times on this aircraft.",
                "line_delivery_exemption": "&bull; <b>{delivery_exemption_time} minutes free</b> on the flight to your departure airport",
                "line_end_premium": "Login to OpenFly to take advantage of this special offer!",
                "line_end_freemium": "Login to OpenFly to learn more!",
                "action": "See plane",
                "exemple": "Examples of an organized trip",
                "line_rent_plane": "from <b>{departureAirport}</b> with this plane and one of the professional pilots:"
            },
            "new-plane-nearby": {
                "subject": "New aircraft from {city} on Openfly",
                "greeting_premium": "Dear member,",
                "greeting_freemium": "Hello,",
                "line_1": "A new aircraft, located near your airport, has been added to the OpenFly platform, here are the details:",
                "line_rent_plane": "Examples of an organized trip from <b>{departureAirport}</b> with this aircraft and one of our licensed professional pilots:",
                "line_asterisk": "&#42; Based on a round trip, excluding airport taxes and handling fees, with {passengers} passengers on board.",
                "view": "VIEW",
                "view_plane": "See the plane",
                "other_destinations": "Other destinations",
                "price_range_per_passenger_from_zero": "Less than {maxPrice} € one way per passenger *",
                "price_range_per_passenger": "From {minPrice} € to {maxPrice} € one way per passenger *"
            },
            "new-member-notice": {
                "subject": "New Premium club member"
            },
            "plane-authorization-modified": {
                "subject": "{pilotName} changed some information about his authorization to fly your plane",
                "header": "Modification of authorization",
                "pilot-modified-elements": "{pilotName} changed the following elements about his authorization to fly your plane:",
                "see-authorization-details-info": "You can look at the details of this authorization by clicking on the button below:",
                "see-authorization-button": "See authorization",
                "greeting": "Hello {ownerName},"
            },
            "new-plane-unavailability": {
                "subject": "The aircraft {immatriculation} will be unavailable from {start} to {end}",
                "header": "The aircraft {immatriculation} will be unavailable",
                "greeting": "{firstname}",
                "line_1": "{owner}, owner of {plane} registered {immatriculation}, indicated that his plane would be unavailable from {start} au {end}.",
                "line_2": "You can view this unavailability window on your calendar by clicking on the button below:",
                "button": "See unavailability"
            },
            "new-pilot-unavailability": {
                "subject": "{pilot} will be unavailable from {start} to {end}",
                "greeting": "{firstname}",
                "line_1": "{pilot}, authorized to fly your aircraft, indicated that he would be unavailable from {start} au {end}.",
                "line_2": "You can view this unavailability window on your calendar by clicking on the button below:",
                "button": "See unavailability"
            },
            "new-plane-unavailabilities-to-pilot": {
                "subject": "The owner of plane registered {plane} added new unavailabilities",
                "greeting": "Hello {firstname},",
                "explanation": "{owner}, owner of the aircraft registered {immatriculation} which you are authorized to fly, indicated that their {model} would not be available on the following dates:"
            },
            "new-pilot-unavailabilities-to-owner": {
                "subject": "The pilot {pilot} added unavailabilities",
                "greeting": "Hello {firstname},",
                "explanation": "{pilot}, authorized to pilot your aircraft registered {immatriculation}, indicated that he is not available on the following dates:"
            },
            "wallet": {
                "credited-to-member": {
                    "subject": "Your OpenFly Wallet has been credited with {amount} €",
                    "header": "Your OpenFly Wallet has been credited",
                    "greeting": "Dear member",
                    "line1": "You credited your OpenFly Wallet for {amount} €.",
                    "line2": "You’ll find the details of this transaction below:"
                },
                "credited-to-entity-admin": {
                    "subject": "{firstname} {lastname} credited your OpenFly Wallet with {amount} €",
                    "greeting": "Hi {firstname}",
                    "line1": "{firstname} {lastname} credited your OpenFly Wallet for {amount} €.",
                    "line2": "You’ll find the details of this transaction below:"
                },
                "kyc-failed-to-support": {
                    "subject-id": "La validation de la pièce d’identité de {firstname} {lastname} a échoué",
                    "subject-kbis": "La validation de l'extrait de Kbis de {firstname} {lastname} a échoué",
                    "subject-status": "La validation de l'extrait de Kbis de {firstname} {lastname} a échoué",
                    "subject-ubo": "La validation de l'extrait de Kbis de {firstname} {lastname} a échoué",
                    "subject-address": "La validation de l'extrait de Kbis de {firstname} {lastname} a échoué",
                    "greeting": "Bonjour,",
                    "line1-id": "{firstname} {lastname} a envoyé un pièce d’identité à OpenFly pour validation et pour permettre le retrait de fonds de son porte-monnaie OpenFly.",
                    "line1-kbis": "{firstname} {lastname} a envoyé son extrait de Kbis à OpenFly pour validation et pour permettre le retrait de fonds de son porte-monnaie OpenFly.",
                    "line1-status": "{firstname} {lastname} a envoyé son statut à OpenFly pour validation et pour permettre le retrait de fonds de son porte-monnaie OpenFly.",
                    "line1-ubo": "{firstname} {lastname} a envoyé sa déclaration d'actionnaires à OpenFly pour validation et pour permettre le retrait de fonds de son porte-monnaie OpenFly.",
                    "line1-address": "{firstname} {lastname} a envoyé sa déclaration d'adresse à OpenFly pour validation et pour permettre le retrait de fonds de son porte-monnaie OpenFly.",
                    "line2": "The document provided could not be validated for the following reason: {motif}",
                    "action": "Accéder au profil"
                },
                "kyc-failed-to-user": {
                    "subject-id": "Validation of your identity document failed",
                    "subject-kbis": "Validation of your Kbis extract failed",
                    "subject-status": "Validation of your company statutes failed",
                    "subject-ubo": "Validation of your shareholder declaration failed",
                    "subject-address": "The validation of your address declaration failed",
                    "greeting": "Hello {firstname} {lastname},",
                    "line1-id": "You have sent your ID to OpenFly for validation and to allow the withdrawal of funds from your OpenFly wallet.",
                    "line1-kbis": "You have sent your Kbis certificate to OpenFly for validation and to allow the withdrawal of funds from your OpenFly wallet",
                    "line1-status": "You have sent your Status to OpenFly for validation and to allow the retrieval of funds from your OpenFly wallet",
                    "line1-ubo": "You have sent your shareholder statement to OpenFly for validation and to allow the withdrawal of funds from your OpenFly wallet",
                    "line1-address": "You have sent your address declaration to OpenFly for validation and to allow the withdrawal of funds from your OpenFly wallet",
                    "line2": "The document provided could not be validated for the following reason: {motif}",
                    "line3": "Please upload a new document.",
                    "action": "My wallet",
                    "line4": "If you need help, please write to support@openfly.fr or contact +33 2 85 29 57 57 directly.",
                    "line5": "We are at your disposal for any further information."
                },
                "kyc-validated": {
                    "subject": "You can now retreive funds from your wallet",
                    "greeting": "Hi {firstname} {lastname},",
                    "line1": "Following the upload of the necessary documents to confirm your identity, your account has been validated.",
                    "line2": "You can now withdraw funds from your OpenFly wallet.",
                    "action": "View my balance"
                },
                "mandate-failed-to-support": {
                    "subject": "La validation du mandat de prélèvement de {firstname} {lastname} a échoué",
                    "greeting": "Bonjour,",
                    "line1": "{firstname} {lastname} a fait une demande d’ajout d’un mandat de prélèvement pour alimenter son porte-monnaie OpenFly.",
                    "line2": "Cette demande n’a pas pu aboutir.",
                    "action": "Accéder au profil"
                },
                "mandate-failed-to-user": {
                    "subject": "The validation of your direct debit mandate has failed",
                    "greeting": "Hello {firstname},",
                    "line1": "You have made a request to add a direct debit mandate to fund your OpenFly wallet and make booking requests.",
                    "line2": "This request was unsuccessful, please check the bank details used, and try again.",
                    "action": "My OpenFly wallet"
                },
                "payin-failed": {
                    "subject": "Your OpenFly wallet couldn’t be credited",
                    "greeting": "Hi {firstname},",
                    "line1": "You have tried to credit your OpenFly wallet with {amount} {currency} on {date}.",
                    "line2": "The payment your card {card} failed, for the following reason: {reason}",
                    "line_try_again_booking": "The booking linked to this payment has been kept, however the pilot will be more likely to cancel it if your wallet isn’t credited with the correct amount for this booking. We ask you to try again to complete the transaction.",
                    "line_try_again_no_booking": "You can try to credit your wallet again by clicking on the button below:",
                    "action": "Credit my wallet"
                },
                "payout-failed-to-support": {
                    "subject": "Withdrawing from {firstname} {lastname}'s wallet failed",
                    "greeting": "Hi,",
                    "line1": "{firstname} {lastname} a tenté de retirer un montant de {amount} {currency} de son porte-monnaie OpenFly le {date}.",
                    "line2": "This operation could not be completed.",
                    "action": "Access profile"
                },
                "payout-failed-to-user": {
                    "subject": "Withdrawing from your OpenFly Wallet failed",
                    "greeting": "Hi {firstname},",
                    "line1": "You tried to withdraw {amount} {currency} from your OpenFly wallet on {date}.",
                    "line2": "This operation couldn’t be completed for this reason :",
                    "action": "My OpenFly Wallet"
                },
                "transaction-motive": {
                    "supply": "Supply",
                    "withdrawal": "Withdrawal"
                },
                "transfer-failed-to-support": {
                    "subject": "Transferring funds to {firstname} {lastname}'s OpenFly wallet failed",
                    "greeting": "Hi,",
                    "line1": "Following the validation of booking number {bookingNumber} for {entityName}, transferring funds from the client’s wallet to {firstname} {lastname}'s has failed.",
                    "line2": "This request was unsuccessful: {error}.",
                    "action": "View the booking"
                },
                "transfer-failed-to-user": {
                    "subject": "Transferring funds to your OpenFly wallet failed",
                    "greeting": "Hi {firstname},",
                    "line1": "Following the validation of booking number {bookingNumber} for {entityName}, transferring funds from the client’s wallet to yours has failed.",
                    "line2": "Please contact our support team to fix this problem."
                },
                "transfer-issue": {
                    "subject": "Error during money transfer",
                    "greeting": "Hi,",
                    "description": "The transfer from from {debitedFullname}'s wallet to {creditedFullname}, for an amount of {amount} €, failed ({status})"
                },
                "amount": "Amount",
                "motive": "Motive",
                "transaction": "Transaction",
                "withdraw-created-to-member": {
                    "subject": "Withdrawal from your wallet is pending verification",
                    "greeting": "Hello,",
                    "line1": "You have sent a withdrawal request of {amount} € from your OpenFly wallet.",
                    "line2": "Here are the details of this transaction:",
                    "line3": "This transaction is being verified. You will be informed by email as soon as it is validated. "
                },
                "withdraw-created-to-entity-admin": {
                    "subject": "Withdrawal from your wallet is pending verification",
                    "greeting": "Hello {firstname},",
                    "line1": "{firstname} {lastname} has sent a withdrawal request of {amount} € from your OpenFly wallet.",
                    "line2": "Here are the details of this transaction:",
                    "line3": "This transaction is being verified. You will be informed by email as soon as it is validated. "
                },
                "withdraw-to-member": {
                    "subject": "You withdrew {amount} € from your OpenFly Wallet",
                    "header": "Your wallet has been debited",
                    "greeting": "Hi {firstname}",
                    "line1": "You withdrew {amount} € from your OpenFly Wallet.",
                    "line2": "You’ll find the details of this transaction below:"
                },
                "withdraw-to-entity-admin": {
                    "subject": "{firstname} {lastname} withdrew {amount} € from your OpenFly Wallet",
                    "greeting": "Hi {firstname}",
                    "line1": "{firstname} {lastname} withdrew {amount} € from your OpenFly Wallet",
                    "line2": "You’ll find the details of this transaction below:"
                },
                "withdraw-to-support": {
                    "subject": "Nouvelle facture de frais OpenFly à émettre",
                    "greeting": "Bonjour,",
                    "line1": "Un retrait de fonds a été opéré depuis un porte-monnaie OpenFly. Voici les informations pour l'émission de la facture associée :"
                },
                "transfert-to-support": {
                    "subject": "Nouvelle facture de frais OpenFly à émettre",
                    "greeting": "Bonjour,",
                    "line1": "Un nouveau vol a été validé, entraînant deux nouvelles factures de débours à émettre."
                },
                "user-validated-to-support": {
                    "subject": "The identity of {firstname} {lastname} has been validated for cash withdrawal",
                    "greeting": "Hi,",
                    "line1": "The documents and the UBO form of {firstname} {lastname} have been validated by Mangopay.",
                    "line2": "Users can now withdraw funds from their OpenFly wallet."
                },
                "user-validated-to-user": {
                    "subject": "You can now retreive funds from your wallet",
                    "greeting": "Hi {firstname} {lastname},",
                    "line1": "After sending the necessary documents to validate your identity, your account has been validated. ",
                    "line2": "You can now withdraw funds from your OpenFly wallet.",
                    "action": "SEE MY BALANCE"
                },
                "ubo-incomplete-to-support": {
                    "subject": "The identity verification of {firstname} {lastname} has been refused by Mangopay",
                    "greeting": "Hello Support,",
                    "line1": "The identity of {firstname} {lastname} has been rejected by MangoPay for the following reason:",
                    "line2": "The withdrawal of funds is still blocked. "
                },
                "ubo-incomplete-to-user": {
                    "subject": "Your identity has not been validated for retrieval of funds from your wallet",
                    "greeting": "Hello {firstname} {lastname},",
                    "line1": "After sending your request for validation of your identity for the retrieval of funds, your account could not be validated for the following reason:",
                    "line2": "There is incomplete information in the company's shareholder identity form.",
                    "line3": "We invite you to make a new application with the correct information.",
                    "line4": "If you need help, please write to support@openfly.fr or contact +33 2 85 29 57 57 directly.",
                    "action": "My wallet"
                },
                "ubo-failed-to-user": {
                    "subject": "Your identity has not been validated for retrieval of funds from your wallet",
                    "greeting": "Hello {firstname} {lastname},",
                    "line1": "After sending your request for validation of your identity for the retrieval of funds, your account could not be validated for the following reason:",
                    "line2": "There is invalid information in the company's shareholder identity form.",
                    "line3": "We invite you to make a new application with the correct information.",
                    "line4": "If you need help, please write to support@openfly.fr or contact +33 2 85 29 57 57 directly.",
                    "action": "My wallet"
                }
            },
            "routefinder-error": {
                "error": "Une erreur RouteFinder est survenue : ",
                "from": "Aéroport de départ : ",
                "to": "Aéroport de arrivée : "
            },
            "premium-membership-cancellation": {
                "subject": {
                    "today": "Your Club OpenFly Premium subscription ends today",
                    "other": "Your Club OpenFly Premium subscription ends in {remainingDays} day|Your Club OpenFly Premium subscription ends in {remainingDays} days"
                },
                "greeting": "Dear Member,",
                "line_1": "You elected to cancel your Club OpenFly Premium membership. Your access to our Premium service won't be avaible starting from {contractEndDate}.<br><br>However, you'll keep your usual access to the platform and will still be able to make estimates, without the ability to book a trip.",
                "line_2": "If you wish to stop the cancellation process, please call us as soon as possible at\\: 02 52 59 59 59."
            },
            "flight-mentions": {
                "private_professional": "<b>As a reminder</b>, you are organizing this trip as private air transport, on behalf of your company, by entering into two separate contracts:\n        <br>&bull; one for the piloting services provided by the professional Pilot you have selected, and\n        <br>&bull; one for the dry lease of the aircraft with the owner of said aircraft.",
                "private_individual": "<b>As a reminder</b>, you are organizing this trip as private air transport, for your own account, by entering into two separate contracts:\n        <br>&bull; one for the piloting services provided by the professional Pilot you have selected, and\n        <br>&bull; one for the dry lease of the aircraft with the owner of said aircraft.",
                "public": "Flights carried out by an Airline are considered commercial air transport operations.<br>Commercial flights are performed under the responsibility of the operator, otherwise designated as air carrier, whose activity is contingent upon the posession of an operating permit and an air operator's certificate (A.O.C.)."
            },
            "scheduled-funding-info": {
                "subject": "Your OpenFly wallet is going to be credited for your {trip} trip",
                "greeting": "Hi {firstname},",
                "line-1": "We're letting you know that we are going to credit your OpenFly wallet with an amount of {amount}, according to the following booking request you made on {booking_date}:",
                "line-2-directDebit": "Your wallet will be credited using the bank account ending in {payment_method_ending}.",
                "line-2-CB": "Your wallet will be credited using the credit card ending in {payment_method_ending}."
            },
            "new-passenger-feedback": {
                "subject": "New review from {fullname}",
                "greeting": "Hello {firstname},",
                "line": "A new feedback has been published by {fullname} following the booking made by {entity} concerning the trip from {departure} to {arrival} on {date}.",
                "link": "View feedback"
            },
            "delete-account-request": {
                "subject": "Demande de suppression de compte",
                "greeting": "Bonjour",
                "line": "{fullname} a effectué une demande de suppression de compte.",
                "line2": "{id} : {email} - {phone} - {entity}"
            },
            "inform-owner-insurance": {
                "subject-1": "One of your aircraft's documents has expired",
                "subject-2": "Some of your plane's documents have expired",
                "greeting": "Hi {firstname},",
                "line": "A booking has been made for your aircraft {modele} {immatriculation} and cannot be accepted by the pilot because {document} is expired.",
                "line-multi": "A booking has been made for your aircraft {modele} {immatriculation} and cannot be accepted by the pilot because several of your device's documents have expired.",
                "line2": "The insurance certificate and the latest valid maintenance report are mandatory documents for OpenFly.",
                "line3": "Please update this document as soon as possible to allow the pilot to answer to the client.",
                "link": "Update the document",
                "plane-last-maintenance-report": "the last maintenance report",
                "plane-insurance": "the certificate of insurance"
            },
            "plane-document-uploaded": {
                "subject": "Updated document for the aircraft {model}",
                "greeting": "Hi {firstname},",
                "intro": "The owner of the aircraft {model} {immatriculation} has updated a document.",
                "line1": "You can now answer the reservation request waiting.",
                "line2": "You can now respond to pending booking requests.",
                "action": "Management of booking requests"
            },
            "new-document-request-to-pilot-notification": {
                "subject": "New request for access to your documents",
                "greetings": "Hello {firstname},",
                "text": "An OpenFly Premium member ({memberName} - {entityName}) wishes to consult your pilot documents (pilot license and medical certificate).",
                "button-label": "Accept the request",
                "thanks": "Thank you and have a nice day!"
            },
            "new-document-request-to-owner-notification": {
                "subject": "New request for access to your aircraft documents",
                "greetings": "Hello {firstname},",
                "text": "An OpenFly Premium member ({memberName} - {entityName}) wishes to consult your aircraft documents (registration, airworthiness, and insurance certificates).",
                "button-label": "Accept the request",
                "thanks": "Thank you and have a nice day!"
            },
            "document-request-accepted-notification": {
                "subject": "Your request for access to documents has been accepted",
                "greetings": "Dear member,",
                "pilot-text-1": "The pilot {pilotFirstname} has accepted your request for access to the documents.",
                "pilot-text-2": "You can now freely consult the documents of this pilot.",
                "plane-text-1": "The owner of the aircraft {planeModel} has accepted your request for access to the documents.",
                "plane-text-2": "You can now freely consult the documents of this aircraft.",
                "thanks": "Thank you and have a nice day!"
            },
            "booking-offer-payment-reminder": {
                "subject": "Pre-payment pending for the flight from {bookingDepartureCity} on {bookingDepartureDate}",
                "header": "Pre-payment pending",
                "line-1": "You have not yet funded your wallet following the acceptance of your booking request by the pilot.",
                "line-2": "For the good organization of your trip, we invite you to proceed to the pre-payment of your reservation within {delay} hours, without which, it will be automatically cancelled."
            },
            "booking-offer-reply-to-proposal-reminder": {
                "subject": "Response pending for the flight from {bookingDepartureCity} on {bookingDepartureDate}",
                "header": "Response pending",
                "line-1": "The pilot and owner of the {planeModel} aircraft are waiting for you to respond to their proposal.",
                "line-2": "<b>For the good organisation of your trip, we invite you to respond to the proposal and to proceed to the pre-payment within {delay} hours, otherwise, it will be automatically cancelled.</b>",
                "button-label": "Reply to proposal"
            },
            "booking-offer-reply-to-proposal-reminder-to-support": {
                "subject": "Proposition sans réponse sur une demande de réservation",
                "header": "Proposition sans réponse",
                "greeting": "Bonjour,",
                "booking-no": "Réservation n° {bookingId}",
                "line-1": "Il reste {delay} heures au client pour répondre à l'offre du pilote {pilotName}, sans quoi la proposition sera automatiquement annulée :"
            },
            "booking-offer-payment-reminder-to-support": {
                "subject": "Pré-paiement en attente sur une demande de réservation",
                "greeting": "Bonjour,",
                "booking-no": "Réservation n° {bookingId}",
                "line-1": "Il reste {delay} heures au client pour alimenter son porte-monnaie pour la réservation suivante suite à l'acceptation du pilote, sans quoi la réservation sera automatiquement annulée :"
            },
            "booking-cancelled-unpaid": {
                "subject": "Booking no. {bookingId} cancelled - {tripDescription}",
                "header": "Booking cancelled",
                "line-1": "<b>Your reservation with the {planeModel} has been cancelled</b> today because you did not fund your e-wallet within 72 hours of the pilot's reply.",
                "line-2": "You can send a new request if you wish. This time, make sure you respond quickly to the pilot by funding your wallet with the necessary amount.",
                "button-label": "New request"
            },
            "booking-prepaid-to-member": {
                "subject": "Organization of your trip with departure from {bookingDepartureCity} on {bookingDepartureDate}",
                "header": "Organization of your trip",
                "line-1": "For the good organization of your trip departing from {bookingDepartureCity} on {bookingDepartureDate} on board the {planeModel} aircraft, you will find, below, the contact information of the selected professional pilot:",
                "line-2": "The total amount of the booking will be transferred to the pilot and the owner once the flight is completed.",
                "button-label": "View booking"
            },
            "booking-prepaid-to-passenger": {
                "subject": "Trip confirmed {tripDescription}",
                "header": "Trip confirmed",
                "line-1": "{memberName} has organized a trip via OpenFly in which you participate.",
                "line-2": "Please find below the contact information of your professional pilot:",
                "line-3": "As a reminder, {entityName} organizes this trip within the framework of private air transport, for its own account, by concluding two distinct contracts, namely :\n        <br>- a contract for pilotage services with the selected Professional Pilot, and\n        <br>- a bareboat lease agreement with the owner of the aircraft",
                "security-info": "For safety reasons, some items are not accepted on board the aircraft, in particular explosives, gas or firecrackers, or any product identified as \"dangerous\" according to the IATA aviation regulations, which can be consulted on the Internet.",
                "co2": "For the record, {entityName} <b>offsets 100% of the CO2</b> emissions generated by this trip via a contribution to the <a href=“https://aero4good.org” target=“_blank”>Aero4good</a> association, which actively supports the transition to more sustainable aviation. Aero4good funds initiatives enabling pilot training schools and partner flying clubs to carry out flights in electric rather than thermal aircraft."
            },
            "booking-prepaid-to-pilot": {
                "subject": "Information for the flight from {bookingDepartureCity} on {bookingDepartureDate}",
                "header": "Information for the flight",
                "line-1": "The client made the pre-payment on his e-wallet for the booking of the {planeModel} {registrationNumber} aircraft departing from {bookingDepartureCity} on {bookingDepartureDate}.",
                "line-2": "Please find below the contact details of the client:",
                "line-3": "The total amount of the booking will be transferred to the owner and to you once the service has been provided.",
                "line-4": "You are covered for this trip by Aircraft Civil Liability Insurance for the pilot, offered by OpenFly with SAAM Verspieren. To find out more about this insurance, <a href=\"https://www.openfly.fr/en/pilots-insurance.html\">click here</a>. This insurance is automatically included for all trips organized by Premium Members via the OpenFly platform.",
                "button-label": "View booking"
            },
            "booking-prepaid-to-owner": {
                "subject": "Information for the flight from {bookingDepartureCity} on {bookingDepartureDate}",
                "header": "Information for the flight",
                "line-1-with-wallet": "The client made the pre-payment on his e-wallet for the booking of the {planeModel} {registrationNumber} aircraft departing from {bookingDepartureCity} on {bookingDepartureDate}.",
                "line-1-without-wallet": "The client accepted the pilot's offer to book the flight from {bookingDepartureCity} on {bookingDepartureDate} on board the {planeModel} {registrationNumber} aircraft.",
                "line-2": "The total amount of the booking will be transferred to you and the pilot once the service has been provided.",
                "button-label": "View booking"
            },
            "booking-canceled-by-entity-to-user": {
                "subject": "Booking no. {bookingId} canceled - {tripDescription} on {bookingStartDate}",
                "header": "Booking canceled<br><small><i>Booking n°: {number}</small>",
                "greeting": "Hello {firstname} {lastname},",
                "explanation": "You have cancelled your booking for the {planeModel} {registrationNumber}  aircraft with the pilot {pilotFirstname} {pilotLastname} for the following trip:",
                "cancellation-reason": "Reason for cancellation: {cancellationReason}",
                "pilot-and-owner-informed": "We have informed the pilot and owner.",
                "refund-info": "The funds for this booking are now available in your e-wallet. You can use them for another booking, make a withdrawal to the bank account of your choice or <a href=\"{refundLink}\">make a withdrawal of funds</a>."
            },
            "booking-offer-cancelled-unanswered": {
                "subject": "Offer canceled - {tripDescription}",
                "header": "Offer canceled",
                "line-1": "The offer of {pilotName} pilot with the aircraft {planeModel} has been cancelled today because you did not reply within 72 hours.",
                "no-other-pending-estimates": "You can send a new request if you wish. This time, make sure you respond quickly to the pilot by funding your wallet with the necessary amount.",
                "new-booking": "NEW REQUEST",
                "other-pending-estimates": "You still have a proposal pending on this booking.",
                "view-proposal": "VIEW THE PROPOSAL"
            },
            "booking-canceled-unanswered-to-pilot": {
                "subject": "Offer no. {bookingId} canceled - {tripDescription}",
                "greeting": "Hello {firstname} {lastname},",
                "line-1": "Your offer with the {planeModel} has been cancelled today because the client did not reply within 72 hours."
            },
            "booking-canceled-unanswered-to-owner": {
                "subject": "Offer no. {bookingId} canceled - {tripDescription}",
                "header": "Offer canceled<br><small><i>Booking n°: {number}</small>",
                "greeting": "Hello {firstname} {lastname},",
                "line-1": "The offer of the pilot {pilotFirstname} {pilotLastname} on your plane {planeModel}, registered {planeRegistration} is cancelled because it has not been replied to by the client."
            },
            "qualification-expiration-upcoming-30-days-to-pilot": {
                "subject": "Your {qualificationName} pilot qualification expires in 1 month",
                "greeting": "Hello {firstname} {lastname},",
                "line-1": "Your {qualificationName} pilot qualification expires in 1 month.",
                "line-2": "To update the qualification, go to your pilot profile. You will be able to add the new expiry date and a copy of your up-to-date licence.",
                "action-label": "Update"
            },
            "qualification-expiration-upcoming-14-days-to-pilot": {
                "subject": "Your {qualificationName} pilot qualification expires in 2 weeks",
                "greeting": "Hello {firstname} {lastname},",
                "line-1": "Your {qualificationName} pilot qualification expires in 2 weeks.",
                "line-2": "To update the qualification, go to your pilot profile. You will be able to add the new expiry date and a copy of your up-to-date licence.",
                "action-label": "Update"
            },
            "confirm-newsletter-registration": {
                "subject": "Confirm your subscription to OpenFly's newsletter",
                "greeting": "Hello,",
                "intro": "You requested to subcribe to OpenFly's newsletter. To confirm your subscription, please click on the button below.",
                "button-label": "Confirm my subscription"
            },
            "booking-offer-table": {
                "departure": "Departure:"
            },
            "query-legs-htmlable": {
                "title": "YOUR REQUEST",
                "title-pilot": "TRAVEL",
                "departure_at": "Departure at&nbsp;<b>{departure}</b>.",
                "passagers": "With 1 passenger|With {nb} passengers",
                "button-label": "See reservation details",
                "plane-selected": "SELECTED AIRCRAFT|SELECTED AIRCRAFTS"
            },
            "legs-updated-htmlable": {
                "title": "NEW DEPARTURE TIME"
            },
            "contract-and-payment-pending": {
                "greeting": "Dear Member,",
                "subject": "Confirmation of your OpenFly Premium membership",
                "line-1": "The OpenFly team would like to welcome you as a Premium member. Your Premium membership has been received.",
                "line-2": "<b>Your membership contract</b> is attached.",
                "line-3": "<b>Your Premium account will be activated within 72 hours.</b>. You will be informed by email when your membership has been activated.",
                "line-3-stripe": "We have received payment for your <b>OpenFly Premium membership</b> and can confirm that it has been <b>activated</b>.",
                "salutation": "Thank you for your confidence."
            },
            "contract-and-payment-confirmed": {
                "greeting": "Dear Member,",
                "subject": "Your OpenFly Premium Membership",
                "line-1": "The whole OpenFly team welcomes you among our Premium members.",
                "line-2": "We have received <b>payment for your membership</b> and can confirm that it has been activated. Your membership contract is attached.",
                "line-3": "You will receive the invoice shortly.",
                "salutation": "Thank you for your confidence.<br><br>Best regards,<br><br>Lolita Vigouroux<br><br><div style=\"text-align: center; margin-left: auto; margin-right: auto;\"><table><tr><td><img src=\"https://dev.openfly.fr/imgs/customer-manager.jpeg\" alt=\"Customer Manager\" style=\"max-width: 90%; width: 800px;\" /></td></tr></table></div>",
                "my-premium-area": "Book a plane"
            },
            "contract-payment-confirmed": {
                "greeting": "Dear Member,",
                "subject": "Activation of your OpenFly membership",
                "line-1": "We have received payment for your <b>OpenFly Premium membership</b> and can confirm that it has been <b>activated</b>.",
                "line-2": "You will receive the invoice shortly.",
                "salutation": "Thank you for your confidence.",
                "my-premium-area": "Book a plane"
            },
            "contract-payment-failed": {
                "greeting": "Dear Member,",
                "subject": "Payment failed for your OpenFly membership",
                "line-1": "Payment of your OpenFly Premium membership has failed.",
                "line-2": "Your membership could not be activated because the direct debit was rejected by your bank.",
                "line-3": "Please contact support at support@openfly.fr or +33 2 85 29 57 57 to pay for your membership using another method of payment.",
                "salutation": "Thank you for your confidence."
            },
            "premium-possibilities": {
                "you-can-now": "You can now:",
                "contact-pilots": "Contact the professional pilots and book the private aircraft listed",
                "reach-airlines": "Have unlimited access to partner airlines",
                "join-flights": "Join the remaining seats on flights shared by other members thanks to Nautics"
            },
            "plane-validated": {
                "subject": "Validation of your aircraft",
                "greeting": "Dear owner,",
                "line-1": "We are pleased to announce that your <b>{planeModel} {registrationNumber}</b> has been validated by our services.",
                "line-2": "You will now be able to receive requests for authorisation from pilots registered on OpenFly.",
                "line-3": "Attached you will find <b>a guide to good practice</b> on the platform.",
                "line-4": "We remain at your disposal for any further information."
            },
            "blocked-offer-media-expiration": {
                "subject": "Reservation blocked because of the document  {document}",
                "greeting": "Hello {fullname},",
                "line1": "A booking request for your aircraft {model} {immatriculation} is blocked because of your {document}. ",
                "line2": "The pilot cannot accept it because it will have expired at the time of departure.",
                "button": "Update"
            },
            "rex-plane-comment-to-owner": {
                "subject": "A pilot has added a comment about your aircraft",
                "explanation": "During the validation of the last flight with your aircraft {model} {immatriculation}, the pilot {pilot} added a comment to send to you:"
            },
            "aero4good-certificate": {
                "subject": "OpenFly - Your carbon offset certificate",
                "header": "Your carbon offset certificate",
                "greeting": "Hi {fullname},",
                "line1": "After booking validation {flightType} {flightLegs} the {flightDates} with the plane {plane}, we are pleased to send you in attachment your <b>Carbon Offset Certificate</b> and the <b>Receipt of payment</b> made to the Aero4good Association, via your electronic wallet.",
                "line2": "<a href=\"https://aero4good.org/\">Aero4good</a> is an association that participates in the implementation of electric aircraft flights in pilot training schools and partner aero clubs.",
                "line3": "Thank you for contributing to the decarbonization of the air."
            }
        },
        "most-searched-trips": {
            "page-title": "Trajets les plus recherchés",
            "intro": "Avec OpenFly, 1er portail de location d'avions privés, vous pouvez louer un avion privé ou un jet privé pour vous déplacer au départ et à destination de plus de 400 aéroports et aérodromes en France et 4000 en Europe, directement et sans correspondance.",
            "list-intro": "Trajets les plus demandés par les membres inscrits"
        },
        "passenger-feedback": {
            "page-title": "Customer feedback",
            "travel-description": "Route : {description}",
            "feedback-date": "Feedback sent on {date}",
            "used-plane": "Aircraft rent : {plane}"
        },
        "global": {
            "short-date-format": "m/d/Y",
            "short-date-format-no-year": "d/m",
            "short-date-letter-format": "M d Y",
            "datetime-format": "m/d/Y H{i}",
            "datetime-format-string": "On m/d/Y at H{i}",
            "localized-short-date-format": "%b/%d/%Y",
            "localized-short-date-letter-format": "%b %d %Y",
            "localized-datetime-format": "%b/%d/%Y %H:%M",
            "time-format": "H\\hi",
            "duration-format": "G\\hi",
            "moment-datetime-format": "MM/DD/Y at HH[H]mm",
            "yes": "Yes",
            "no": "No",
            "plane": "Plane",
            "pilot": "Pilot",
            "route": "Route",
            "airaffaires-flight": "openfly.fr Flight",
            "booking-company": "Booker",
            "passenger": "passenger",
            "passengers": "Passengers",
            "week-day-0": "sunday",
            "week-day-1": "monday",
            "week-day-2": "tuesday",
            "week-day-3": "wednesday",
            "week-day-4": "thursday",
            "week-day-5": "friday",
            "week-day-6": "saturday",
            "shorter-day-0": "S",
            "shorter-day-1": "M",
            "shorter-day-2": "T",
            "shorter-day-3": "W",
            "shorter-day-4": "T",
            "shorter-day-5": "F",
            "shorter-day-6": "S",
            "short-day-0": "Sun",
            "short-day-1": "Mon",
            "short-day-2": "Tue",
            "short-day-3": "Wed",
            "short-day-4": "thu",
            "short-day-5": "Fri",
            "short-day-6": "Sat",
            "month-1": "January",
            "month-2": "February",
            "month-3": "March",
            "month-4": "April",
            "month-5": "May",
            "month-6": "June",
            "month-7": "July",
            "month-8": "August",
            "month-9": "September",
            "month-10": "October",
            "month-11": "November",
            "month-12": "December",
            "short-month-1": "Jan",
            "short-month-2": "Feb",
            "short-month-3": "Mar",
            "short-month-4": "Apr",
            "short-month-5": "May",
            "short-month-6": "Jun",
            "short-month-7": "Jul",
            "short-month-8": "Aug",
            "short-month-9": "Sep",
            "short-month-10": "Oct",
            "short-month-11": "Nov",
            "short-month-12": "Dec",
            "language-labels": {
                "fr": "Français",
                "en": "English",
                "de": "Deutsch"
            },
            "unsubscription": "Unsubscription",
            "price-without-taxes": "{price} excl. tax",
            "price-with-taxes": "{price} incl. tax",
            "price-estim-without-taxes": "Estimation : {price} HT",
            "price-estim-with-taxes": "Estimation : {price} TTC",
            "cancel": "Cancel",
            "ok": "OK",
            "vue-material-date-format": "MM/dd/yyyy",
            "vue-material-date-format-moment": "MM/DD/Y",
            "newsletter-registration-confirmed": "Your subscription to the newsletter has been confirmed.",
            "close": "Close",
            "or": "or"
        },
        "stripe": {
            "errors": {
                "card_declined": "The card has been declined.",
                "expired_card": "This card has expired. Please check the expiration date or use another card",
                "instant_payouts_unsupported": "This card can't process instant payments. Please use another card, or your bank account instead.",
                "invalid_card_type": "This card type is invalid.",
                "invalid_source_usage": "This card is unavailable.",
                "invalid_number": "The card number format is invalid.",
                "incorrect_number": "The card number is incorrect.",
                "invalid_expiry_month": "The expiry month is invalid.",
                "invalid_expiry_year": "The expiry year is invalid.",
                "invalid_cvc": "The CVC code is invalid.",
                "incorrect_cvc": "The CVC code format is incorrect.",
                "missing": "This card isn't linked to this user.",
                "processing_error": "An error occured while processing the request."
            }
        },
        "pagination": {
            "previous": "&laquo; Previous",
            "next": "Next &raquo;"
        },
        "press": {
            "index-page-title": "They're talking about us",
            "read-post": "Read the post",
            "download-file": "Download the document",
            "title": "Press",
            "subtitle": "The press is talking about OpenFly",
            "view-video": "Watch the video",
            "download-press-kit": "Download the press kit",
            "press-kit-description": "All you need to talk about OpenFly",
            "contact-infos": "Contact us",
            "contact": "Contact our press service"
        },
        "contract": {
            "form-title": "To join the OpenFly Premium Club, please fill in the fields below:",
            "iban": "IBAN",
            "bic": "BIC",
            "siren": "SIRET / DUNS",
            "duns": "Company ID Number / DUNS",
            "made-at": "Done at",
            "quality": "Quality",
            "sponsor": "Sponsor code",
            "rib": "Add your RIB",
            "iban-file": "Add your IBAN",
            "validation_code": "SMS code",
            "phone": "Mobile phone",
            "validate-contract": "Validate",
            "regenerate-contract": "Regenerate contract",
            "sms-code-text": "To validate the contract, please enter the following code : {code}\nThis code is available for 5 minutes",
            "sign-text": "SIGNED ELECTRONICALLY",
            "sign-date": "the {date} at {time}",
            "sign-code": "with code on {phone}",
            "sign-confirmed-with-password": "You can now use the portal to organize your trips! <br /> Click the button below to start:",
            "sign-confirmed-without-password": "To use the platform and organize your trips, please create your password by clicking on the button below",
            "show-contract": "Show the contract",
            "reserve-flight": "Book a plane",
            "create-my-password": "Create my password",
            "code-sent-helper": "We have sent you a validation code on your mobile",
            "resend-code-confirm-title": "Resend a code",
            "resend-code-confirm-desc": "You will receive a new code on this mobile number : {number}",
            "cancel": "Cancel",
            "bad_sponsor": "Bad sponsor code",
            "bad_code": "Invalid SMS code",
            "expired_code": "Expired SMS code",
            "legal-representative-firstname": "Legal representative first name",
            "legal-representative-lastname": "Legal representative last name",
            "user-birthdate": "Birth date",
            "legal-representative-birthdate": "Legal representative birth date",
            "legal-representative-country": "Legal representative living country",
            "legal-representative-birth-country": "Legal representative birth country",
            "file-too-big": "The file is too large (> 10MB)",
            "bad_siren": "Invalid SIRET format",
            "legal_representative_birthdate_too_late": "The legal representative must be at least 18 years old.",
            "invalid-promo-code": "Invalid promo code",
            "bank-country": "Bank country",
            "account-holder-name": "Account holder",
            "bank": "Bank",
            "confirm-payment": "Validate",
            "transaction-number": "Transaction no.: {transaction}",
            "company-infos": "Company informations",
            "legal-representative": "Legal representative",
            "promo-code": "PROMO CODE",
            "sponsor-code": "SPONSORSHIP CODE",
            "recurrence-footnote": "* for an initial commitment of {months} months, then {recurringPrice} € excl. tax/year tacitly renewed, limited to one establishment (1 SIRET). VAT according to current regulations.",
            "recurrence-footnote-individual": "* At the end of the initial period, membership is tacitly renewed for successive one-year periods, at the price in force on the day of tacit renewal (currently €{recurringPrice} for {months} months), under the conditions defined in the GCU.",
            "payment": "Payment",
            "payment-info": "Please enter your bank details to set up the SEPA direct debit mandate for your OpenFly Premium membership:",
            "personal-infos": "Personal informations",
            "payment-infos-confirmation": "Payment informations confirmation",
            "signed-welcome-title": "Welcome among our OpenFly Premium Members!",
            "signed-welcome-text": "Your subscription has been processed. Our service will do everything possible to activate your Premium account within 72 hours. You will then be able to make your booking requests.",
            "stripe-signed-welcome-text": "Your subscription has been processed.",
            "signed-discover-button": "Continue on the platform",
            "premium-member-guide": "Guide du Membre Premium",
            "premium-member-guide-description": "Téléchargez dès maintenant notre guide afin d’obtenir toutes les informations utiles pour votre première demande de réservation.",
            "consult-guide-button": "Consulter le guide",
            "months": "months",
            "tos": "By becoming an OpenFly Premium Member, I accept the <a href=\"/en/openfly-terms-of-service.pdf\" target=\"_blank\">terms and conditions of use</a>.",
            "accept-payment": "I expressly agree to the payment of the OpenFly Premium fee.",
            "sepa-mandate": "SEPA Intercompany Direct Debit Mandate",
            "sepa-mandate-individual": "SEPA Direct Debit Mandate",
            "debit-request": "DIRECT DEBIT REQUEST",
            "debit-request-validity": "This request is valid until cancelled by me, to be notified to the creditor in good time.",
            "account-to-debit": "Account to be debited",
            "creditor": "Creditor",
            "sepa-identifier": "SEPA identifier",
            "signature-info": "By signing this mandate form, you authorise (A) OpenFly to send instructions to your bank to debit your account, and (B) your bank to debit your account in accordance with OpenFly’s instructions. This mandate is only intended for business-to-business transactions. You are not entitled to a refund from your bank after your account has been debited, but you are entitled to request to your bank not to debit your account up until the day on which the payment is due.",
            "signature-info-individual": "By signing this mandate form, you authorize (A) OpenFly to instruct your bank to debit your account, and (B) your bank to debit your account in accordance with OpenFly’s instructions. You have the right to request a refund from your bank according to the conditions specified in your agreement with it. All refund requests must be submitted within eight weeks of the date on which your account was debited. Your rights are explained in a statement that you can obtain from your bank.",
            "first-fee": "The first fee is paid immediately after your Premium membership. The SEPA Mandate will be sent to you by email.",
            "engagement-footnote": "* for an initial commitment of {months} months then {recurringPrice} in tacit renewal, limited to one establishment (1 SIRET). VAT according to the regulations in force.",
            "engagement-footnote-months-free": "* for an initial commitment of {months} months including {freeMonths} exceptionally offered then {recurringPrice} in tacit renewal, limited to one establishment (1 SIRET). VAT according to the regulations in force.",
            "engagement-footnote-individual": "* At the end of the initial period of {months} months, the membership is tacitly renewed for successive periods of {months} months, at the rate in effect on the day of tacit renewal (currently: {recurringPrice} for {months} months), under the conditions defined in the T&Cs.",
            "engagement-footnote-individual-months-free": "* At the end of the initial period of {months} months including {freeMonths} exceptionally offered, the membership is tacitly renewed for successive periods of {months} months, at the rate in effect on the day of tacit renewal (currently: {recurringPrice} for {months} months), under the conditions defined in the T&Cs.",
            "general-infos": "General informations",
            "free-months": "+ 1 month free:::+ {count} months free",
            "card-payment-info": "Please enter your credit card details to pay the membership fee. All transactions are secure and encrypted.",
            "total-price": "Total: {price} including tax",
            "apply": "Apply",
            "signing": "Signature in progress, please wait ..."
        },
        "validation": {
            "accepted": "The {attribute} must be accepted",
            "active_url": "The {attribute} is not a valid URL",
            "after": "The {attribute} must be a date after {date}",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}",
            "alpha": "The {attribute} may only contain letters",
            "alpha_dash": "The {attribute} may only contain letters, numbers, dashes and underscores",
            "alpha_num": "The {attribute} may only contain letters and numbers",
            "array": "The {attribute} must be an array",
            "before": "The {attribute} must be a date before {date}",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}",
            "between": {
                "numeric": "The {attribute} must be between {min} and {max}",
                "file": "The {attribute} must be between {min} and {max} kilobytes",
                "string": "The {attribute} must be between {min} and {max} characters",
                "array": "The {attribute} must have between {min} and {max} items"
            },
            "boolean": "The {attribute} field must be true or false",
            "confirmed": "The {attribute} confirmation does not match",
            "date": "The {attribute} is not a valid date",
            "date_equals": "The {attribute} must be a date equal to {date}",
            "date_format": "The {attribute} does not match the format {format}",
            "different": "The {attribute} and {other} must be different",
            "digits": "The {attribute} must be {digits} digits",
            "digits_between": "The {attribute} must be between {min} and {max} digits",
            "dimensions": "The {attribute} has invalid image dimensions",
            "distinct": "The {attribute} field has a duplicate value",
            "email": "The {attribute} must be a valid email address",
            "ends_with": "The {attribute} must end with one of the following: {values}",
            "exists": "The selected {attribute} is invalid",
            "file": "The {attribute} must be a file",
            "filled": "The {attribute} field must have a value",
            "gt": {
                "numeric": "The {attribute} must be greater than {value}",
                "file": "The {attribute} must be greater than {value} kilobytes",
                "string": "The {attribute} must be greater than {value} characters",
                "array": "The {attribute} must have more than {value} items"
            },
            "gte": {
                "numeric": "The {attribute} must be greater than or equal {value}",
                "file": "The {attribute} must be greater than or equal {value} kilobytes",
                "string": "The {attribute} must be greater than or equal {value} characters",
                "array": "The {attribute} must have {value} items or more"
            },
            "image": "The {attribute} must be an image",
            "in": "The selected {attribute} is invalid",
            "in_array": "The {attribute} field does not exist in {other}",
            "integer": "The {attribute} must be an integer",
            "ip": "The {attribute} must be a valid IP address",
            "ipv4": "The {attribute} must be a valid IPv4 address",
            "ipv6": "The {attribute} must be a valid IPv6 address",
            "json": "The {attribute} must be a valid JSON string",
            "lt": {
                "numeric": "The {attribute} must be less than {value}",
                "file": "The {attribute} must be less than {value} kilobytes",
                "string": "The {attribute} must be less than {value} characters",
                "array": "The {attribute} must have less than {value} items"
            },
            "lte": {
                "numeric": "The {attribute} must be less than or equal {value}",
                "file": "The {attribute} must be less than or equal {value} kilobytes",
                "string": "The {attribute} must be less than or equal {value} characters",
                "array": "The {attribute} must not have more than {value} items"
            },
            "max": {
                "numeric": "The {attribute} may not be greater than {max}",
                "file": "The {attribute} may not be greater than {max} kilobytes",
                "string": "The {attribute} may not be greater than {max} characters",
                "array": "The {attribute} may not have more than {max} items"
            },
            "mimes": "The {attribute} must be a file of type: {values}",
            "mimetypes": "The {attribute} must be a file of type: {values}",
            "min": {
                "numeric": "The {attribute} must be at least {min}",
                "file": "The {attribute} must be at least {min} kilobytes",
                "string": "The {attribute} must be at least {min} characters",
                "array": "The {attribute} must have at least {min} items"
            },
            "zero_or_min": "The {attribute} must be at least {min}",
            "minlength": "The {attribute} must be greater than or equal {value} characters",
            "maxlength": "The {attribute} must be less than or equal {value} characters",
            "not_in": "The selected {attribute} is invalid",
            "not_regex": "The {attribute} format is invalid",
            "numeric": "The {attribute} must be a number",
            "passwordrules": "8 characters min. with a lowercase, an uppercase and a digit",
            "phone": "The field \"{attribute}\" contains an invalid number",
            "present": "The {attribute} field must be present",
            "regex": "The {attribute} format is invalid",
            "required": "This field is required",
            "required_if": "This field is required",
            "required_unless": "This field is required",
            "required_with": "This field is required",
            "required_with_all": "This field is required",
            "required_without": "This field is required",
            "required_without_all": "This field is required",
            "same": "The {attribute} and {other} must match",
            "size": {
                "numeric": "The {attribute} must be {size}",
                "file": "The {attribute} must be {size} kilobytes",
                "string": "The {attribute} must be {size} characters",
                "array": "The {attribute} must contain {size} items"
            },
            "starts_with": "The {attribute} must start with one of the following: {values}",
            "string": "The {attribute} must be a string",
            "timezone": "The {attribute} must be a valid zone",
            "unique": "The {attribute} has already been taken",
            "uploaded": "The {attribute} failed to upload",
            "url": "The {attribute} format is invalid",
            "uuid": "The {attribute} must be a valid UUID",
            "iban": "The {attribute} must be a valid IBAN",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                },
                "email": {
                    "required": "Field \"Email\" must be filled",
                    "unique": "This email address is already tied to an existing account. Try to <a href=\"/member/login\">Log In</a>",
                    "non-disposable": "Temporary email addresses are not accepted",
                    "invalid": "This email address is invalid"
                },
                "entity-type": {
                    "required": "Please select in what capacity you are traveling"
                },
                "airport_id": {
                    "required": "FIeld \"City\" must be filled"
                },
                "destination_airport_id": {
                    "required": "Please choose a destination"
                },
                "password": {
                    "same": "The two passwords must be identical",
                    "size": "Password need to have at least {size} characters"
                },
                "password_confirmation": {
                    "same": "The two passwords must be identical",
                    "size": "Password need to have at least {size} characters"
                },
                "passenger-email": {
                    "unique": "This email address is already tied to an existing passenger"
                },
                "file_cv": {
                    "lte": "CV size must be under or equal to 2 Mo"
                },
                "file_motivation_letter": {
                    "lte": "Cover letter file size must be under or equal to 2Mo"
                },
                "airport": {
                    "required": "\"Airport\" field must be filled"
                },
                "language": {
                    "required": "\"Language\" field must be filled"
                },
                "pilot": {
                    "unique": "You are already registered as a pilot on the platform, please log in to use our services"
                },
                "owner": {
                    "unique": "VoYou are already registered as an owner on the platform, please log in to use our services"
                },
                "pilot-owner": {
                    "unique": "You are already registered as a pilot and an owner on the platform, please log in to use our services"
                },
                "company": {
                    "unique": "You are already registered as a company on the platform, please log in to use our services"
                },
                "after-now": {
                    "date": "The {attribute} must be a date after today"
                },
                "pilot-id": {
                    "required": "The ID is required"
                },
                "pilot-license": {
                    "required": "The license is required"
                },
                "pilot-medical-certificate": {
                    "required": "The medical certificate is required"
                },
                "pilot-class-1-medical-certificate": {
                    "required": "The class 1 medical certificate is required"
                },
                "pilot-class-2-medical-certificate": {
                    "required": "The class 2 medical certificate is required"
                },
                "pilot-cv": {
                    "required": "The CV is required"
                },
                "qualifications": {
                    "not_in": "You must select a least one qualification"
                },
                "intracommunity_vat_number": {
                    "required_unless": "The {attribute} field is required"
                },
                "dateNaissance": {
                    "after_or_equal": "Invalid birth date",
                    "before_or_equal": "Invalid birth date"
                }
            },
            "attributes": {
                "name": "Name",
                "username": "Username",
                "email": "Email",
                "firstname": "First Name",
                "first_name": "First Name",
                "prenom": "First Name",
                "lastname": "Last Name",
                "last_name": "Last Name",
                "nom": "Last Name",
                "password": "Password",
                "password_confirmation": "Password Confirmation",
                "city": "city",
                "country": "country",
                "address": "address",
                "phone": "Phone Number",
                "telephone": "Phone Number",
                "entity_phone": "Phone Number",
                "entity_type": "Entity type",
                "mobile": "mobile phone",
                "age": "age",
                "sex": "sex",
                "gender": "gender",
                "day": "day",
                "month": "month",
                "year": "year",
                "hour": "hour",
                "minute": "minute",
                "second": "second",
                "title": "title",
                "content": "content",
                "description": "description",
                "excerpt": "excerpt",
                "date": "date",
                "time": "hour",
                "available": "available",
                "size": "size",
                "entity_name": "Name",
                "entity_address": "Address",
                "entity_postcode": "Postal/Zip Code",
                "postalCode": "Postal/Zip Code",
                "entity_city": "City",
                "entity_country": "Country",
                "entity_country_id": "Country",
                "body": "message",
                "value": "value",
                "company": "company",
                "key": "Key",
                "questions.*.question": "Question",
                "questions.*.body": "Answer",
                "job_name": "Sought Position",
                "file_cv": "CV",
                "entries.*.title": "Title",
                "entries.*.url": "Link",
                "entries.*.pdf_url": "PDF Link",
                "entries.*.youtube_url": "Youtube_url",
                "entries.*.date_published": "Publication Date",
                "siren": "SIRET/DUNS",
                "companyRegistrationNumber": "SIRET/DUNS",
                "vitesseCroisiere": "Cruising Speed",
                "nbPassagerMax": "Maximu passenger capacity",
                "mtow": "Maximum Take Off Weight",
                "status": "Status",
                "pilot-license": "License",
                "pilot-id": "ID Document",
                "pilot-medical-certificate": "Medical Certificate",
                "pilot-class-1-medical-certificate": "Class 1 Medical Certificate",
                "pilot-class-2-medical-certificate": "Class 2 Medical Certificate",
                "plane-registration-certificate": "Registration Certificate",
                "plane-navigability-certificate": "Certificate of airworthiness",
                "plane-last-maintenance-report": "Last maintenance report",
                "plane-insurance": "Insurance",
                "role": "Role",
                "departureAirport": "Departure airport",
                "lang": "Language",
                "executiveEntityParent": "Executive entity parent",
                "legal_status": "\"You are\"",
                "decline_motive": "Decline motive",
                "airline_name": "Airline name",
                "discovery_mode_percentage": "First flight discount percentage",
                "discovery_mode_enabled": "Enable first flight offer",
                "entity_iban": "IBAN",
                "fidelity_offer_min_flights": "\"Number of flights to enable the loyalty discount\"",
                "fidelity_offer_percentage": "\"Loyalty discount percentage\"",
                "last_minute_offer_percentage": "\"Last Minute discount percentage\"",
                "early_booking_offer_percentage": "\"Early Booking discount percentage\"",
                "temporary_discount_percentage": "\"Flight hours discount percentage\"",
                "temporary_routing_discount_percentage": "\"Routing discount percentage\"",
                "temporary_discount_start_at": "\"Temporary Discount start date\"",
                "temporary_discount_end_at": "\"Temporary Discount end date\"",
                "landing_amount": "Landing amount",
                "mtow_min": "MTOW min",
                "mtow_max": "MTOW max",
                "landing_price_mode": "Mode calcul prix atterrissage",
                "parking_franchise": "Parking Franchise",
                "day_parking_amount": "Day Parking Amount",
                "night_parking_amount": "Night Parking Amount",
                "hourly_parking_fee": "Hourly Parking Fee",
                "daily_parking_fee": "Daily Parking Fee",
                "night_landing_amount": "Night Landing Amount",
                "additional_fees_amount": "Additional Fees Amount",
                "entity_bic": "BIC",
                "hourly_rate": "Hourly rate",
                "routing_hourly_rate": "Routing hourly rate",
                "daily_rate": "Daily rate",
                "fraisDeMiseEnPlace": "Setup fee",
                "customerGroup": "Group",
                "entity_rib": "RIB",
                "entityType": "Entity type",
                "entity_type_id": "Entity type",
                "legal_representative_firstname": "Legal reprensentative first name",
                "legal_representative_lastname": "Legal reprensentative last name",
                "legal_representative_birthdate": "Legal reprensentative birth date",
                "legal_representative_country_id": "Legal reprensentative living country",
                "legal_representative_birth_country_id": "Legal reprensentative birth country",
                "yourNeed": "Need",
                "user_birthdate": "Birth date"
            },
            "unique_passenger": "{attribute} field value is already used",
            "discovery_mode_percentage": "You must define a First flight discount percentage for the discovery offer"
        },
        "media": {
            "plane-registration-certificate": "registration certificate",
            "plane-navigability-certificate": "certificate of airworthiness",
            "plane-last-maintenance-report": "last maintenance report",
            "plane-insurance": "insurance",
            "pilot-medical-certificate": "Medical Certificate",
            "pilot-class-1-medical-certificate": "Class 1 Medical Certificate",
            "pilot-class-2-medical-certificate": "Class 2 Medical Certificate",
            "pilot-id": "ID card"
        },
        "job-candidature": {
            "form-title": "Spontaneous Application",
            "job_name": "Position sought",
            "first_name": "First Name",
            "last_name": "Last Name",
            "email": "Email Address",
            "phone": "Phone Number",
            "english_level": "Your english level",
            "cv": "Send your C.V.",
            "motivation_letter": "Covering letter (optional)",
            "submit": "Send",
            "message": "Message",
            "submitted-title": "Your application has been sent.",
            "submitted-content": "We'll get back to you very soon. Thank you for your interest.",
            "english-level-0": "Beginner",
            "english-level-1": "Medium",
            "english-level-2": "Advanced",
            "english-level-3": "Expert"
        },
        "mangopay": {
            "api-iban-error": "The IBAN entered is invalid",
            "api-bic-error": "The BIC entered is invalid",
            "statement-descriptor": "Wallet OpenFly",
            "kyc-file-too-big": "The file size cannot exceed 7 MB",
            "kyc-file-too-small": "The file size cannot be less than 32 KB"
        },
        "home": {
            "home": "Home",
            "the-club": "The Club",
            "professionals": "Aviation Professionals",
            "security": "Security",
            "contact": "Contact",
            "become-member": "Register",
            "company": "Company",
            "about": "Àbout",
            "faq": "Frequently Asked Questions",
            "registration-form": "Registration Form",
            "terms-and-conditions": "Terms and Conditions",
            "terms-and-conditions-link": "/en/openfly-terms-of-service.pdf",
            "press": "Press",
            "press-area": "Press Area",
            "pilots": "Professional Pilots",
            "needed-qualifications": "Required Qualifications",
            "offer-services": "Offer my services",
            "plane-owner": "Plane Owners",
            "plane-owner-short": "Owners",
            "ecology": "Ecology",
            "companies": "Companies",
            "wanted-planes": "Wanted Planes",
            "offer-my-plane": "Offer my plane",
            "join-us": "Join Us",
            "follow-us": "Follow Us",
            "close": "Close",
            "cookies-info": "We use cookies to provide the best possible experience on our website. By browsing this site, you accept the usage of cookies. For more information, please read our <a href=\"/politique-confidentialite.html\">privacy policy</a>.",
            "cookies.analytics-description": "Use of cookies for measurement and user experience optimisation",
            "cookies.essential-description": "Essential cookies",
            "cookies.ad-user-description": "Advertising-related user data cookies",
            "cookies.ad-personalization-description": "Consent cookies for personalized advertising",
            "cookies.refuse-all": "Refuse all",
            "cookies.accept-all": "Accept all",
            "cookies.refuse": "I refuse",
            "cookies.accept": "I agree",
            "cookies.save-preferences": "Save settings",
            "cookies.preferences": "Settings",
            "cookies.we-respect-your-privacy": "We respect your privacy",
            "select-language": "Select language",
            "home-article": {
                "title": "Reasons to organise your own trips with a private aircraft",
                "block1": {
                    "title": "Flexible",
                    "description": "Leave and come back when you want"
                },
                "block2": {
                    "title": "Fast",
                    "description": "Don't queue to board"
                },
                "block3": {
                    "title": "Responsible",
                    "description": "Fly safely and eco-friendly"
                },
                "block4": {
                    "title": "Accessible",
                    "description": "No matter where you live or what your budget is"
                },
                "read-more": "Read more"
            },
            "home-article2": {
                "title": "They are talking about us"
            },
            "read-more": "Read more",
            "how-it-works": "How does it work?",
            "how-it-works-body": "<b>As a member of Club OpenFly, planning your professional travels is extremely simple:</b> you fly from and where you want to by using the closest airports to your departure and arrival locations.",
            "how-it-works-1": "Become a Member",
            "how-it-works-2": "Plan your flight, choosing your departure and arrival locations, and your date and time, directly from the website",
            "how-it-works-3": "Choose your plane and professional pilot based on the prices and estimated flight durations",
            "how-it-works-4": "Finalize the details of your trip directly with your professional pilot",
            "how-it-works-5": "Fly, and adjust your departure time<br>depending on your schedule!",
            "plane-exemples-title": "A few available plane types",
            "speed": "Speed",
            "passengers": "Passengers",
            "company-executives-title": "The private plane renting platform, accessible anywhere in France and Europe",
            "company-executives-body": "\n        <h2>Business Flying, finally made accessible!</h2>\n        <ul>\n            <li style=\"margin-bottom: 8px;\"><span>Leave and come back whenever you want, wherever you want</span></li>\n            <li style=\"margin-bottom: 8px;\"><span>An airport located less than 30km from your workplace or meeting</span></li>\n            <li style=\"margin-bottom: 8px;\"><span>Freely plan your trips by choosing the plane and the professional pilot, with just a few clicks</span></li>\n            <li style=\"margin-bottom: 8px;\"><span>Rethink your trips by organizing same-day multi-leg flights, or spread them over multiple days</span></li>\n        </ul>\n        <p>Even with the internet, one out of two business flyers thinks human contact is still essential.</p>\n        <p>Join the OpenFly Club and fly bespoke.</p>\n        <a href=\"/dirigeants-cadres-pme.html\" class=\"md-button md-raised md-primary md-theme-default\">\n            <div class=\"md-ripple md-disabled\">\n                <div class=\"md-button-content\">Read More</div>\n            </div>\n        </a>\n    ",
            "benefits-title": "Your time is valuable",
            "benefits-intro": "Example of journeys made in one day in a private aircraft",
            "flight-time-examples-passengers": "{passengers} passengers",
            "flight-time-examples-by-car": "By car",
            "flight-time-examples-by-train": "By train",
            "flight-time-examples-by-plane": "By airliner",
            "flight-time-examples-estimation": "Estimation:",
            "flight-time-examples-impossible": "Impossible",
            "flight-time-examples-with-openfly": "With OpenFly in a propeller plane:",
            "private-flight-news": "Private aviation news",
            "more-than-2000-airports": "More than 2000 airports",
            "reachable-in-europe": "accessible in Europe",
            "you-are-pilot": "Are you a professional pilot?",
            "you-are-owner": "Are you a plane owner?",
            "they-trust-us": "They trust us",
            "testimonial-quote": "Congratulations to the OpenFly Team for their availability and advice, as a user at first, then as a potential airplane owner.",
            "testimonial-quote-author": "Thierry Morter",
            "testimonial-quote-author-role": "President of BABOU",
            "they-testify": "Testimonials",
            "login": "Log in",
            "contact-us": "Contact Us",
            "partners": "Partners",
            "phone": "Phone",
            "contact-us-question": "A question?",
            "copyright": "©2025 OpenFly - All rights reserved",
            "legal-mentions": "Legal",
            "privacy-policy": "Privacy policy",
            "i-register": "Register",
            "page-not-found": "Page not found",
            "page-not-found-message": "The requested page couldn't be found.<br>If you think it's an error, you can contact us using the form below.",
            "sitemap": "Sitemap",
            "pages": "Pages",
            "registration-form-download": "Registration form",
            "can-register-online": "<p>You can now register online. To register, click the button below:</p><a href=\"/\" class=\"md-button md-raised md-primary md-theme-default\"><div class=\"md-ripple md-disabled\"><div class=\"md-button-content\">Register</div></div></a><p><small>To download a copy of the registration form, click <a href=\"/content/formulaire-abonnement-openfly.pdf\" target=\"_blank\">here</a>.</small></p><p>If you have any questions, you can contact us by phone: +33252595959 or by mail contact@openfly.fr .</p>",
            "phone-number": "+33252595959",
            "connect": "Log in",
            "http-500-title": "Error",
            "http-500-message": "<p>There was an error while loading the page. Please try again later.<br>If the problem persists, you can contact us by email at <a href=\"mailto:contact@openfly.fr\">contact@openfly.fr</a> or by phone: +33252595959.<br>Please excuse us for any inconvenience.</p>",
            "service-unavailable-title": "We'll be back soon!",
            "service-unavailable-message": "<p>A maintenance operation is underway, for a planned duration of 2 hours. The service is temporarily unavailable. Please try again later.<br><br>You can contact us by email at <a href=\"mailto:contact@openfly.fr\">contact@openfly.fr</a> or by phone:  +33252595959.<br><br>Please excuse us for any inconvenience.</p>",
            "blog": {
                "title": "Blog",
                "no-items": "There are currently no article."
            },
            "location-jet-prive": {
                "button": "Rent a private aircraft"
            },
            "avantages-aviation-affaires": {
                "button": "Discover the service"
            },
            "aviation-affaires-accessible": {
                "button": "See prices"
            },
            "aviation-affaires-deplacements-pros": {
                "button": "Register"
            },
            "louer-ou-acheter-avion-prive": {
                "button": "Rent a private aircraft"
            },
            "continue": "Continue",
            "becomes": "becomes",
            "name-change-modal-text": "1er portail de location d'avions à la demande,<br><br>pour une aviation responsable, flexible et accessible",
            "see-more-flight-time-examples": "See more case studies",
            "most-searched-trips": "Most popular routes",
            "view-more-news": "View more news",
            "view-more-trips": "View more trips",
            "testimonials-title": "Voice of our members",
            "select-site-country": "Country",
            "select-site-language": "Language",
            "download-app": "Download our mobile app",
            "see-more-testimonials": "See more testimonials",
            "discover-openfly-for-free": "Discover OpenFly for free",
            "openfly-4-pillars": "The 4 pillars of OpenFly",
            "4-pillars": {
                "our-engagements": "Our engagements",
                "productivity": "Productivity",
                "productivity-details": "Move efficiently, according to your own constraints, optimizing your time",
                "productivity-max-time": "Maximum time to reach your destination anywhere in France",
                "opening-up": "Opening up",
                "opening-up-details": "Participate in the opening up of territories to allow companies to develop their activity from their region",
                "opening-up-distance": "average distance from the nearest airfield to your home",
                "opening-up-airport-count": "aerodromes in France and Europe",
                "linking": "Linking",
                "linking-details": "Promote the sharing of mobility resources by connecting private aviation players with companies with travel needs",
                "linking-done": "connections made",
                "ecology": "Ecology",
                "ecology-details": "Claim the place of private aviation as an optimal solution to connect territories with a limited environmental impact",
                "up-to": "Up to",
                "less-emissions-than-a-jet": "less emissions than a jet",
                "propeller-planes": "propeller planes",
                "need-travelling": "Need to move?"
            },
            "more-news": "See more news",
            "newsletter": "Newsletter",
            "newsletter-i-register": "I register",
            "newsletter-confidentiality": "By signing up you agree to our Privacy Policy",
            "newsletter-follow-us": "Follow us",
            "newsletter-title": "To keep you informed about the decarbonization of private aviation",
            "newsletter-registration-confirmation": "Thank you for your registration. A confirmation email has been sent to you.",
            "newsletter-your-email": "Your email",
            "private-aviation-with-low-emissions": "Accessible low-emission private aviation",
            "join-our-community": "Discover sober and accessible private aviation by organizing your trips directly with professional pilots.",
            "why-openfly": "Why OpenFly?",
            "register-on-openfly": "Register on OpenFly",
            "register": "Register",
            "join-openfly": "Join OpenFly"
        },
        "registration-other": {
            "profil-title-generic": "Register",
            "profil-intro": "To join the Club, please fill in your profile :",
            "entity": "Company",
            "profil-offer-type": "Do you want to offer",
            "profil-offer-pilot": "Your professional pilot services",
            "profil-offer-plane-location": "Renting your plane",
            "profil-offer-company": "Your airline services",
            "profil-user-type-company": "You represent an airline company",
            "yes": "Yes",
            "no": "No",
            "pilot-owner": "Plane owner",
            "pilot-no-owner": "Not a plane owner",
            "owner-pilot": "Pilot",
            "owner-no-pilot": "Not a pilot",
            "pilot-CPL-certified": "CPL, IFR pilot, without a plane",
            "pilot-CPL-certified-owner": "CPL, IFR pilot, and plane owner",
            "owner-IFR": "IFR plane owner wishing to offer his plane on the platform",
            "owner-IFR-and-pilot": "IFR plane owner and IFR? CPL pilot",
            "company": "Company wishing to offer its planes and crews on the platform",
            "password-creation-email-explanation": "To finish creating your account, an email has been sent to you. It contains the instructions to create your password.",
            "welcome": "Welcome on OpenFly",
            "slide-pilot-1": "<b>Increase your flying hours</b> however you want to, by taking passengers on board<br /><br />",
            "slide-pilot-2": "<b>Earn money</b> by filling up the plane seats, and by sharing expenses<br /><br />",
            "slide-pilot-3": "<b>Develop your network</b> with the Club OpenFly clients<br /><br />",
            "slide-owner-1": "<b>Lend your plane and optimize its profitability</b> thanks to business flying, by reducing time spent in the hangar<br /><br />",
            "slide-owner-2": "<b>Reduce operating costs</b> and grounded, inactive time<br /><br />",
            "slide-owner-3": "<b>Know that </b> your plane is flown by professionals, and join a network of business owners and pilotes<br /><br />",
            "slide-company-1": "<b>Optimize how your airplane fleet is used</b>, and take advantage of free visibility on the first business flying platform in Europe<br /><br />",
            "slide-company-2": "<b>Draw a network</b> of business flying executives and entrepreneurs to your company<br /><br />",
            "slide-company-3": "<b>Registration is free</b>, and you are in control of how and when your planes and crews are made available<br /><br />",
            "accept-tos": "I accept the&nbsp;<a href=\"/en/openfly-terms-of-service.pdf\" target=\"_blank\">TOS</a>",
            "find-way": "How did you hear about us?"
        },
        "main-menu": {
            "premium-club": "Premium Club",
            "ecology": "Ecology",
            "security": "Security",
            "home": "Home",
            "our-services": "our services",
            "individuals": "Individuals"
        },
        "blog": {
            "blog": "Blog",
            "title": "Business aviation news",
            "subtitle": "All business aviation news",
            "read-more": "Read more",
            "latest-article": "Latest article",
            "update-date": "Updated",
            "publication-date": "Published",
            "publication-by": "by",
            "pilots": {
                "section-title": "To join us, you need :",
                "join-its-free": "Join OpenFly, registration is free!",
                "increase-flight-hours": "Increase your flight hours on your terms by flying passengers for business trips...",
                "develop-network": "Develop your network and make your skills known to the clients our platform brings you...",
                "register-for-free": "Register for free",
                "we-seek-pilot-with-experience": "We are looking for pilots of aircraft suitable for business flights, with their Commercial Pilot Licence (CPL) and at least 500 hours of flight time.",
                "home-card-title": "Join OpenFly, registration is free!",
                "home-card-content": "",
                "home-card-button-label": "I register for free"
            },
            "owners": {
                "join-its-free": "Join OpenFly, registration is free!",
                "we-week-owners": "We are looking for owners of aircraft suitable for business flights and aircraft maintained as per the EASA or FAA standards.",
                "register-for-free": "Register for free",
                "home-card-title": "Join OpenFly, registration is free!",
                "home-card-content": "",
                "home-card-button-label": "I register for free",
                "reference-my-plane": "Reference my aircraft",
                "simulate-income": "Simulate the revenue your aircraft could generate by being listed on OpenFly",
                "select-aircraft-type": "Select an aircraft type",
                "income-by-year": "€ {income} excl. VAT / year *",
                "income-info": "Annual revenue achievable by renting your aircraft for 150 hours a year",
                "footnote": "* For an average rental price of €{pricePerHour} / flight hour"
            },
            "the-club": {
                "section-title": "Fly on demand!",
                "home-card-title": "Need to travel?",
                "home-card-content": "",
                "home-card-button-label": "I register for free",
                "search-for-a-trip": "Search for a trip",
                "discover-planes": "Discover aircrafts"
            },
            "our-services": {
                "home-card-title": "Need to travel?",
                "home-card-content": "",
                "home-card-button-label": "I register for free"
            }
        },
        "registration": {
            "flight-price-alt": "<font size=\"3\"><b>{totalPrice}&nbsp;€&nbsp;R/T</b></font> for {nbPassengersMax} pass. max. (or {pricePerPassenger}&nbsp;€&nbsp;excl. tax&nbsp;/&nbsp;passenger)",
            "flight-price": "<b>Estimation: {totalPrice}&nbsp;€&nbsp;R/T<sup>*</sup></b><br>",
            "flight-price-per-passenger": "(or €{pricePerPassenger} excl. tax/passenger)",
            "flight-price-without-taxes-per-passenger": "(or €{pricePerPassenger} excl. tax/passenger)",
            "flight-price-with-taxes-per-passenger": "(or €{pricePerPassenger} incl. tax/passenger)",
            "lastname": "Last Name",
            "firstname": "First Name",
            "phone": "Phone Number",
            "mobile": "Mobile phone",
            "entity-type": "Entity Type",
            "entity-type-label": "You are: ",
            "flight-as-label": "You wish to travel as",
            "job-label": "Function practised : ",
            "entity-role": "Your Role",
            "password": "Password",
            "password-confirmation": "Confirm Password",
            "continue": "Continue",
            "details": "Details",
            "discover-service": "Discover the service",
            "begin": "Verify",
            "register": "Register",
            "search": "Search",
            "entity-type-company": "Company",
            "entity-type-individual": "Individual",
            "entity-type-association": "Non-profit",
            "entity-type-public-organization": "Public Organization",
            "entity-type-other": "Other",
            "fill-profile": "<strong>To discover the service, please fill in your profile</strong>",
            "fill-profile-2": "<strong>To try out the service during 3 days, without commitment, please fill in your profile</strong>",
            "fill-entity": "Your entity",
            "check-place-availability": "Check if OpenFly is available near your company:",
            "your-city": "City",
            "your-email": "Email",
            "departure-airport": "Departure airport",
            "favorite-airport": "Favorite airport",
            "slogan-a": "Rent a plane as easily as a car!",
            "slogan-b": "First on-demand<br> private airplane rental portal",
            "slogan-sub": "Accessible low-emission private aviation",
            "slogan-covid19": "First on-demand<br> airplane rental portal",
            "slogan-covid19-subtitle": "<a href=\"/registration/fill-profile/23\" class=\"md-button md-raised md-primary md-theme-default\"><span class=\"md-ripple md-disabled\"><span class=\"md-button-content\">Learn more</span></span></a>",
            "air-affaires-present-in-city": "OpenFly is available at {airportName} ({iata})",
            "need-to-travel": "Need to travel ?",
            "i-register-for-free": "I register for free",
            "your-departure": "Your departure",
            "your-destination": "Your destination",
            "select-destination": "Where would you like to directly fly to<br>from {city} ?",
            "entity-name": "Company name",
            "entity-address": "Address",
            "entity-postcode": "Postal / ZIP Code",
            "entity-city": "City",
            "entity-country": "Country",
            "intracommunity-vat-number": "Intracommunity VAT number",
            "step-profile": "Profile",
            "step-entity": "Entity",
            "step-subscription": "Subscription",
            "payment-title": "Subscribe to Club OpenFly",
            "subscription-condition": "* Then annual membership fee of {amount} {currency} excluding tax by automatic renewal. Cancelable with a 3 months notice.",
            "subscription-condition-v2": "* Then annual membership fee of {amount} {currency} {vat} excluding tax by automatic renewal. Cancelable with a 3 months notice.",
            "subscription-annual": "Annual cotisation",
            "subscription-annual-amount": "{amount} {currency} without tax",
            "subscription-annual-amountWithTaxes": "Or {amountWithTaxes} {currency} Taxes Included",
            "subscription-discover-semiannual": "Cotisation for the first 6 months",
            "subscription-discover-semiannual-amount": "{amount} {currency} without tax*",
            "subscription-discover-semiannual-amountWithTaxes": "Or {amountWithTaxes} {currency} Incuding Tax",
            "cc-number": "Credit Card Number",
            "cc-expiry": "Expiration (MM/AA)",
            "cc-cvc": "CVC",
            "payment-infos": "Fill in your payment details",
            "discover-without-subscription": "Discover the platofrm, and subscribe later",
            "validate": "Confirm",
            "please-accept-tos": "Please accept the terms and conditions before confirming.",
            "card-rejected": "Payment declined by the bank.",
            "payment-confirmed": "Your payment has been registered.<br>You're now a member of CLub OpenFly",
            "now-member": "Access the booking platform now, and start planning your business trips!",
            "nb-planes-available": "Here is a selection of {nbPlanesDisplayed} private planes available for this trip. {nbAdditionalPlanes} others are also available. Log in or register for free on OpenFly to see them!",
            "max-passengers": "For {maxPassengers} max. pass.",
            "passengers-max": "Max Passengers<br /><b>{maxPassengers}</b>",
            "weight-max": "Max Weight<br /><b>{maxWeight} kg</b>",
            "estimation": "Estimation :",
            "flight-time": "{flightTimeHours}\u0000h{flightTimeMinutes}",
            "flight-time-alt": "<b>{flightTimeHours}\u0000h{flightTimeMinutes}</b>",
            "flight-time-short": "{flightTimeHours}\u0000h{flightTimeMinutes}",
            "search-near-city": "Near {city} ({department_country})",
            "search-city": "{city} ({department_country})",
            "estimated-price-explanation": "* Estimated cost excl. taxes for the plane and the pilot (without airport taxes) for a round trip organized by a Club OpenFly Member.",
            "flight-suggestions-title": "For a trip from ",
            "flight-suggestions-count-1": "Currently",
            "flight-suggestions-count-2": "planes available for this trip",
            "flight-suggestions-alt": "(from {price} € excl. tax for {nbPassenger} passengers max)",
            "flight-suggestions-seo-title": "<h1> <a class=\"airport-link\" href=\"{departureAirportDetailsUrl}\">{departureAirport} ({departureOaci})</a>&nbsp;<a class=\"airport-link-icon\" href=\"{arrivalAirportUrl}\"><i class=\"material-icons\">swap_horiz</i></a>&nbsp;<a class=\"airport-link\" href=\"{arrivalAirportDetailsUrl}\">{arrivalAirport} ({arrivalOaci})</a></h1>",
            "change-destination": "Change",
            "cancel-change-destination": "Cancel",
            "change-departure": "Change",
            "cancel-change-departure": "Cancel",
            "you-wish-to": "You wish to",
            "register-for-free": "Register for free",
            "plan-your-trips": "Plan your trips",
            "offer-your-services": "Offer your services",
            "subscription-infos": "\n        <p>As a Club OpenFly Member, you can:\n            <ul>\n                <li><i class=\"material-icons\">check_circle</i> Fly when you want to, where you want to!</li>\n                <li>\n                    <i class=\"material-icons\">check_circle</i>\n                    Freely plan your trips and optimize your schedule\n                </li>\n                <li>\n                    <i class=\"material-icons\">check_circle</i> Get direct access to plane owners and pilots\n                </li>\n            </ul>\n        </p>\n        <p style=\"padding-top: 10px;\">OpenFly doesn't charge any fee on your flights.</p>\n    ",
            "subscription-infos-title": "<p>As a Club Member, you can:</p>",
            "min-characters": "Passworrd must contain at least {minchars} caractères.",
            "needs-lowercase": "Password must contain at least one lowercase letter.",
            "needs-uppercase": "Password must contain at least one uppercase letter.",
            "needs-digit": "Password must contain at least two numbers.",
            "cannot-select-same-airport-for-departure-and-destination": "Your destination is identical to your departure city. Please select a different destination.",
            "plan-your-trips-info": "You wish to take advantage of business flying at a reasonable cost, and travel how you want to?<br><br><br>",
            "offer-your-services-info": "You are an airline, an IFR plane owner, or a professional pilot, and wish to offer your services to the Club Members?<br><br>",
            "cannot-pay-already-subscribed": "You are already a Club Member, your payment hasn't been taken into account. You will be redirected to the home page. For more information, please contact us by phone: +33252595959.",
            "need-more-infos-payment": "Need more information?<br>Contact us:",
            "contact-form": "Access the contact form",
            "booking-only-for-members": "Booking a trip is exclusively reserved for Club OpenFly members.",
            "need-help": "Need help?",
            "need-help-response": "We are at your disposal to answer all your questions by phone:",
            "phone-number": "+33252595959",
            "phone-number-label": "+33252595959",
            "need-help-phone-hours": "From monday to friday, 9AM to 6PM",
            "password-created": "Your password has been created",
            "can-now-do-this": "Your account has been successfully created.<br>You will now be able to:",
            "access-plane-list": "Access the complete list of airplanes",
            "simulate-booking": "Simulate a booking",
            "make-booking": "Book a business trip",
            "use-mobile-app": "Use the mobile app",
            "can-now-login": "You can log in to the platform using the button below.",
            "password-creation-payment": "You are now a Club OpenFly Member.<br>To complete your account's creation, please create your password below:",
            "password-creation-demo": "You can now try out CLub OpenFly for {days} days without commitment.<br>To complete your account's creation, please create your password below:",
            "password-creation-pay-bill": "You are now a Club OpenFly Member.<br>To complete your account's creation, please create your password below:",
            "create-password": "Create",
            "password-creation-email-explanation": "<p><i class=\"material-icons\">warning</i>&nbsp;We sent you an email. It contains the instructions to create your password.</p>",
            "reverse-trip": "Return flight",
            "have-a-sponsor": "Do you have a sponsor code?",
            "fill-sponsor-code": "Type in your sponsor code",
            "sponsor-code": "Sponsor Code",
            "flight-suggestions-seo-page-title": "{from} {to} flights - Openfly",
            "flight-suggestions-seo-page-head-title": "Flight {from} - {to}",
            "flight-suggestions-seo-page-description": "✈️ Flight departing from {from} and landing at {to}. Flught on a private plane + professional pilot. OpenFly, business flying, made accessible to everyone. Join the club!",
            "pay": "Pay",
            "slogan-pro-pilot": "Flown by an authorized professional pilot",
            "mention": "OpenFly doesn't charge any fee on your flights.",
            "need-accept-cgu": "You must agree to the terms and conditions",
            "service-access": "Join Club OpenFly",
            "service-discovery": "Discover<br />the service",
            "service-demo-description": "During {days} days<br />without commitment",
            "service-demo-description-precision": "(Limited to consultation)",
            "service-discover": "Discover",
            "service-join": "Join the club",
            "service-join-subscription": "Cotisation for the first 6 months : 1190 € (tax not inc.) *",
            "service-join-now": "Pay with credit card",
            "service-join-now-precision": "(activation delay 2 working days)",
            "service-join-bill": "Receive an invoice<br />and pay later",
            "service-join-bill-precision": "(activation period: 2 days)",
            "service-pay-now": "Pay",
            "service-pay-bill": "Subscribe",
            "service-hint": "* Then annual membership fee of 1990 € excluding tax with automatic renewal. Cancelabe with a 3 months notice.",
            "service-hint-with-vat": "* Then annual membership fee of 2388 € including tax with automatic renewal. Cancelabe with a 3 months notice.",
            "service-hint-without-vat": "* Then annual membership fee of 1990 € excluding tax with automatic renewal. Cancelabe with a 3 months notice.",
            "invoice-sent": "The complete activation of your account will take place under 2 business days, after the membership invoice has been sent to you. Until then, you can discover Club Air Affaire's services.",
            "invoice-demo-sent": "The complete activation of your account will take place under 2 business days. Until then, you can discover Club Air Affaire's services.",
            "welcome-to-the-club": "Welcome to Club OpenFly !",
            "start-discovery": "Start your discovery of Club OpenFly !",
            "start-discovery-explanation": "To complete your account's creation, we sent you an email.<br>It contains the instructions to create your password.",
            "bill-explanation": "By choosing to receive an invoice and pay later, your account will be fully activated in 2 business days.<br />\n    The invoice will be addressed to the details you filled in during your registration, for an amount of 1190€, tax not included. It covers a membership period of 6 months*<br /><br />\n    In the meantime, you can use the platform to see which planes are available, and plan your next business trip. You'll be able to complete a booking once your account has been activated.",
            "bill-explanation-with-vat": "By choosing to receive an invoice and pay later, your account will be fully activated in 2 business days.<br />\n    The invoice will be addressed to the details you filled in during your registration, for an amount of 1428€, tax included. It covers a membership period of 6 months*<br /><br />\n    In the meantime, you can use the platform to see which planes are available, and plan your next business trip. You'll be able to complete a booking once your account has been activated.",
            "bill-explanation-without-vat": "By choosing to receive an invoice and pay later, your account will be fully activated in 2 business days.<br />\n    The invoice will be addressed to the details you filled in during your registration, for an amount of 1190€, tax not included. It covers a membership period of 6 months*<br /><br />\n    In the meantime, you can use the platform to see which planes are available, and plan your next business trip. You'll be able to complete a booking once your account has been activated.",
            "bill-confirmation": "Confirm my subscription",
            "termination-conditions": "Cancelation policy",
            "fill-profile-freemium": "<strong>Create your account to access the platform now</strong> (free and without obligation)",
            "create_account": "Create account",
            "complete-profile-explanation": "Complete your profile to discover our service <em>for free</em>, and <em>without commitment</em>!",
            "resend_mail": "Re-send mail",
            "seconds": "wait {seconds} seconds",
            "email-verified": {
                "intro": "Your account has been activated",
                "heading": "You will be redirected to the main page in <span id=\"seconds-timer\"></span> seconds"
            },
            "email-already-verified": {
                "intro": "Votre compte a déjà été activé",
                "heading": "You will be redirected to the main page in <span id=\"seconds-timer\"></span> seconds"
            },
            "legal-status": "You are: ",
            "legal-status-professional": "Professionnal",
            "legal-status-individual": "Individual",
            "phone-format-error": "The phone number must be valid mobile phone",
            "entity-name-required-error": "The \"Social Name\" field is required.",
            "city-id-required-error": "The \"City\" field is required.",
            "know-required-error": "The \"Know\" field is required.",
            "confirm-email": {
                "title": "You are now an OpenFly member!",
                "title2": "Plan your travel now.",
                "subtitle": "We sent an email to <i>{email}</i> to activate your account. Please check your spam folder.",
                "button": "Simulate trips"
            },
            "confirm-email-redirect-to-contract": {
                "title": "Your account has been created.",
                "subtitle": "To finalize your registration, you must activate your account. We sent an email to <i>{email}</i>. Click on the button in that email to finalize your registration.<br /><br />If you don't receive it within 5 minutes, please check your spam folder."
            },
            "valid-email": {
                "title": "Thank you for your request!",
                "subtitle": "We sent you an email to verify your email address.<br />Please check your inbox."
            },
            "unsupported-entity-type": {
                "title": "Thank you for your interest in OpenFly",
                "text": "The OpenFly Club is currently only available to professionals. We will notify you as soon as the service becomes available to individuals."
            },
            "already-flight-with-private-aviation": "I have already flown thanks to private aviation",
            "accept-email": "I would like to receive information from OpenFly",
            "accept-tos": "By continuing I accept the <a href=\"/en/openfly-terms-of-service.pdf\" target=\"_blank\">CGU</a> and the <a href=\"/en/privacy-policy.html\" target=\"_blank\">Privacy Policy</a> of OpenFly",
            "the-club": {
                "organize-for-your-account": "Organize your trip for your own account by selecting your place of departure, arrival and times via the platform",
                "take-advantage": "Take advantage of affordable business aviation",
                "travel-tailor-made": {
                    "title-1": "Maîtrisez votre temps :",
                    "desc-1": "assurez et rentabilisez un ou plusieurs rendez-vous dans la même journée pour vous ou vos collaborateurs, aux horaires que vous fixez : jusqu'à 75% de réduction du temps de déplacement, sans fatigue et sans risque routier.",
                    "title-2": "Simplicité et efficacité :",
                    "desc-2": "accédez à la plateforme de réservation 7j/7, 24h/24, y compris depuis votre mobile. Louez votre avion et fixez les paramètres de votre vol en quelques clics.",
                    "title-3": "Organisez vos déplacements selon vos impératifs :",
                    "desc-3": "vous partez et revenez quand vous le souhaitez, depuis et à destination de l'aéroport le plus près de chez vous ou de vos rendez-vous ! Plus de 350 destinations partout en France (et 2000 en Europe), sans procédures d'embarquement et de débarquement longues et fastidieuses.",
                    "title-4": "Alliez confort et sécurité :",
                    "desc-4": "bénéficiez d'un accueil chaleureux et personnalisé par le pilote professionnel que vous avez sélectionné. Reposez-vous ou travaillez dans les meilleurs conditions pendant votre vol, en toute confidentialité."
                }
            },
            "pilots": {
                "organize-for-your-account": "Augmentez vos heures de vols à votre convenance, en accueillant des passagers pour des déplacements d’affaires... Développez votre réseau et faire connaître votre savoir-faire auprès de la clientèle apportée par notre plateforme...",
                "subtitle": "Live and share your passion while developing your network",
                "travel-tailor-made": {
                    "desc-1": "To be a CPL pilot with at least 500 hours of flying as a pilot-in-command, including at least 20 hours in the last 12 months, and 100 hours as an IFR captain.",
                    "desc-2": "Have up-to-date licenses, including IFR",
                    "desc-3": "Have an up-to-date medical certificate",
                    "desc-4": "Have already flown one of the following aircraft: Cirrus, Piper, TBM, PC-12, Citation Mustang and any type of 6 to 12 seater jet."
                },
                "travel-tailor-made-img": "/imgs/the-club/pilots.webp",
                "pilot-insurance": {
                    "title": "Professional Pilots Liability Insurance",
                    "description": "OpenFly offers to all professional pilots using the platform, a Civil Liability insurance in the context of their piloting services. This insurance is complementary to the compulsory insurance of the aircraft, in case of insufficiency of the latter",
                    "pilot-insurance-img": "/imgs/the-club/pilot-insurance.png",
                    "pilot-insurance-button": "Read more"
                }
            },
            "owners": {
                "title": "Join Club OpenFly",
                "organize-for-your-account": "Augmentez vos heures de vols à votre convenance, en accueillant des passagers pour des déplacements d’affaires... Développez votre réseau et faire connaître votre savoir-faire auprès de la clientèle apportée par notre plateforme...",
                "subtitle": "Improve your plane's return over investment",
                "travel-tailor-made": {
                    "title-1": "Rent your plane",
                    "desc-1": "that spends most of its time in its hangar",
                    "title-2": "Lower exploitation costs",
                    "desc-2": "and inactive time spend grounded",
                    "title-3": "Improve your plane's return over investment",
                    "desc-3": "thanks to business aviation",
                    "title-4": "Rest assured",
                    "desc-4": "that your plane is flown by professionals",
                    "title-5": "Join a network",
                    "desc-5": "of company executives and pilots"
                }
            },
            "validate-phone": {
                "title": "Vérifiez votre numéro de téléphone",
                "description": "Merci de renseigner le code reçu par sms au {phone}",
                "resend-code": "Renvoyer le code",
                "resend-code-snackbar": "Un code vous a été renvoyé par SMS",
                "confirm": "Valider mon inscription",
                "sms-code-text": "Here is your code {code} to complete your registration to OpenFly"
            },
            "accounting-email": "Accounting email",
            "want-to-fly-pro": "Professional",
            "want-to-fly-private": "Private",
            "see-available-planes": "See available planes",
            "find-way": "How did you hear about us?",
            "your-need": "What is your need?",
            "already-member-log-in": "Already registered? Sign in",
            "you-are-pilot": "I am a pilot",
            "you-are-owner": "i am an aircraft owner",
            "function-in-company": "Role in company",
            "access-the-simulator": "Acces the simulator"
        },
        "testimonies": {
            "page-title": "Testimonials",
            "quotes": [
                {
                    "quote": "Congratulations to the OpenFly team for their availability and their advice, as a user first, then as a potential plane owner.",
                    "author_name": "Thierry Morter",
                    "author_role": "President of BABOU",
                    "picture_src": "/imgs/home/testimonials.webp"
                },
                {
                    "quote": "The missing service in Brittany, and that makes us closer to all destinations: Angers, Angoulème, Brest, Lyon",
                    "author_name": "Yves RALLON",
                    "author_role": "Founder and CEO of ePack Hygiene",
                    "picture_src": "/imgs/home/testimonials.webp"
                }
            ]
        }
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/langs/en.js